
(function($) { 
  if (typeof window.showNoProductsMessage !== 'function') {
    window.showNoProductsMessage = function() {
      var noProductsEl = document.getElementById('no-products-inline-message');
      var productGrid = document.getElementById('ProductGridContainer');
      var searchProductList = document.querySelector('.search-product-list');
      var searchHeading = document.querySelector('.search-heading-parent');
      var dynamicFilter = document.querySelector('.product-dynamic-filter-row');
      
      if (noProductsEl && productGrid) {
        if (searchProductList) searchProductList.style.display = 'none';
        if (searchHeading) searchHeading.style.display = 'none';
        if (dynamicFilter) dynamicFilter.style.display = 'none';
        noProductsEl.style.display = 'block';
        productGrid.style.display = 'block';
        var loader = document.querySelector('.brator-cart-item-list-overlay');
        if (loader) loader.classList.remove('open');
        document.getElementById('classic-search-container').scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        if (productGrid) {
          productGrid.innerHTML = '<div style="padding: 80px 20px; text-align: center; min-height: 300px;"><div style="max-width: 600px; margin: 0 auto;"><a href="/" style="display: inline-flex; align-items: center; gap: 8px; color: #f58220; text-decoration: none; font-size: 16px; font-weight: 600; margin-bottom: 30px; cursor: pointer;"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>Back</a><p style="font-size: 24px; line-height: 1.5; color: #000; font-weight: 400; margin: 0;">We\'re sorry, there are no products available for your vehicle at this time.</p></div></div>';
          productGrid.style.display = 'block';
          var loader = document.querySelector('.brator-cart-item-list-overlay');
          if (loader) loader.classList.remove('open');
        }
      }
    };
  }

  // Define hideNoProductsMessage function if not already defined
  if (typeof window.hideNoProductsMessage !== 'function') {
    window.hideNoProductsMessage = function() {
      var noProductsEl = document.getElementById('no-products-inline-message');
      var searchProductList = document.querySelector('.search-product-list');
      var searchHeading = document.querySelector('.search-heading-parent');
      var dynamicFilter = document.querySelector('.product-dynamic-filter-row');
      
      if (noProductsEl) {
        noProductsEl.style.display = 'none';
        if (searchProductList) searchProductList.style.display = '';
        if (searchHeading) searchHeading.style.display = '';
        if (dynamicFilter) dynamicFilter.style.display = '';
      }
    };
  }

  // Define resetLastFilter function to go back without page refresh
  if (typeof window.resetLastFilter !== 'function') {
    window.resetLastFilter = function() {
      if (typeof window.hideNoProductsMessage === 'function') {
        window.hideNoProductsMessage();
      }
      
      // Find the last applied filter (the one with a value that should be reset)
      var filterOrder = ['engineBaseId', 'termModel', 'termMake', 'termYear', 'termDuty'];
      var lastAppliedFilter = null;
      
      for (var i = 0; i < filterOrder.length; i++) {
        var select = document.getElementById(filterOrder[i]);
        if (select && select.value && select.value !== '') {
          lastAppliedFilter = filterOrder[i];
          break;
        }
      }
      
      // If no filter found with value, default to model
      if (!lastAppliedFilter) {
        lastAppliedFilter = 'termModel';
      }
      
      // Reset the last applied filter
      var selectToReset = document.getElementById(lastAppliedFilter);
      if (selectToReset) {
        if (typeof $ !== 'undefined' && $.fn.select2) {
          $(selectToReset).val('').trigger('change');
        } else {
          selectToReset.value = '';
        }
      }
      
      // Hide ProductGridContainer
      var productGrid = document.getElementById('ProductGridContainer');
      if (productGrid) {
        productGrid.style.display = 'none';
      }
      
      // Open the reset dropdown for user to select again
      if (typeof $ !== 'undefined' && $.fn.select2) {
        setTimeout(function() {
          $('#' + lastAppliedFilter).select2('open');
        }, 100);
      }
    };
  }

  const aliasObj = {"AspirationID":"Aspiration","BedLengthID":"Bed Length","BedTypeID":"Bed Type","BodyNumDoorsID":"Body Num Doors","BodyTypeID":"Body Type","BrakeABSID":"Brake ABS","BrakeSystemID":"Brake System","CylinderHeadTypeID":"Cylinder Head Type","DriveTypeID":"Drive Type","EngineBaseID":"Engine Base","EngineDesignationID":"Engine Designation","EngineVersionID":"Engine Version","EngineVINID":"Engine VIN","BrakeTypeID":"Brake Type","SpringTypeID":"Spring Type","FuelDeliverySubTypeID":"Fuel Delivery Sub Type","FuelDeliveryTypeID":"Fuel Delivery Type","FuelSystemControlTypeID":"Fuel System Control Type","FuelSystemDesignID":"Fuel System Design","FuelTypeID":"Fuel Type","IgnitionSystemTypeID":"Ignition System Type","MfrBodyCodeID":"Mfr Body Code","PowerOutputID":"Power Output","BrakeTypeID":"Brake Type","SpringTypeID":"Spring Type","RegionID":"Region","SteeringTypeID":"Steering Type","SteeringSystemID":"Steering System","SubModelID":"Sub Model","ElecControlledID":"Elec Controlled","TransmissionBaseID":"Transmission Base","TransmissionControlTypeID":"Transmission Control Type","MfrID":"Mfr","TransmissionMfrCodeID":"Transmission Mfr Code","TransmissionNumSpeedsID":"Transmission Num Speeds","TransmissionTypeID":"Transmission Type","ValvesID":"Valves","ValvesPerEngineID":"Valves Per Engine","VehicleTypeID":"Vehicle Type","WheelBaseID":"Wheel Base","EngineMfrID":"Engine Mfr"};

  /*################################## Highflow Filter #########################################################*/
  const API_BASE_URL = "https://pgfilters.pgiproduct.com";
  const API_BASE_URL_HIGHFLOW = "https://highflow.pgiproduct.com";
  // var autoCompleteAPI = "https://high.pgiproduct.com/highflow-api/api/v5/advance_filter_v2";
  // var autoCompleteAPI = "https://high.pgiproduct.com/search/api/v3/common/autocompleteData";
  var autoCompleteAPI = "https://high.pgiproduct.com/highflow-api/api/v5/advance_filter_v2";
  // var getProductsURL= "http://high.pgiproduct.com/search/api/v1/getProducts";
  var getProductsURL= "https://highflow.pgiproduct.com/api/v1/common/getProducts";
  // var dynamicSearch = "https://high.pgiproduct.com/search/api/v2/common/dynamicSearch";
  var dynamicSearch = `${API_BASE_URL}/dyanamicCollection_new`;
  var vinAPI = `${API_BASE_URL}/vinCollectionMobikasa`;
  var parentHandleAPI = "https://highflow.pgiproduct.com/api/v1/common/parentHandle";
  let getURL = window.location.href;
  // Only parse hpfilter segments when present. Otherwise `.pop()` returns the full URL and
  // URLValues[0] becomes a non-duty string that later clears #termDuty when assigned.
  let URLValues = [];
  if (getURL.indexOf('search?hpfilter=') > -1) {
    URLValues = getURL.split('search?hpfilter=').pop().split(',');
  }
  let URLValuesForDynamicSearch = getURL.split('search?dsfilter=')[1];
  let collectionPageURL = getURL.split('?filterData=');
  let URLValuesForVINSearch = getURL.split('search?vinSearchfilter=')[1];
  const DEFAULT_DUTY = '2';

  function isValidDutyValue(value) {
    if (value == null || value === '') return false;
    var $duty = $('#termDuty');
    if (!$duty.length) return false;
    return $duty.find('option').filter(function () {
      return String(this.value) === String(value);
    }).length > 0;
  }

  function ensureTermDuty(preferred) {
    var $duty = $('#termDuty');
    if (!$duty.length) return DEFAULT_DUTY;
    if (isValidDutyValue(preferred)) {
      $duty.val(String(preferred));
      return String(preferred);
    }
    var current = $duty.val();
    if (isValidDutyValue(current)) return String(current);
    if (isValidDutyValue(DEFAULT_DUTY)) {
      $duty.val(DEFAULT_DUTY);
      return DEFAULT_DUTY;
    }
    var first = $duty.find('option').first().val();
    if (first) $duty.val(first);
    return first || DEFAULT_DUTY;
  }
  var NSData;
  let selectedQual = [];
  let selectedDynQual = [];
  let extractedValues = new Set();
  let dynamicQualCount = 0;
  let inc = 1;
  let isInitialPageLoad = true; // Flag to prevent scroll on initial page load
  let yearCollection = `${API_BASE_URL}/yearCollection`;
  let makeCollection = `${API_BASE_URL}/makeCollection`;
  let modelCollection = `${API_BASE_URL}/modelCollection`;
  let engineCollection = `${API_BASE_URL}/engineCollection`;
  // let partNumbersExecuted = false;

  // function to show highflow air filter at first position

  function prioritizePartNumber(array) {
    const index = array.findIndex(
      obj => obj.partNumber.startsWith("PA") && obj.partNumber.endsWith("X")
    );
  
    if (index !== -1) {
      const [item] = array.splice(index, 1); 
      array.unshift(item);
    }
  
    return array;
  }

  // end function

  //global function to get partTerminologyID

  function getPartTerminolgyID(collectionType){

    let partTerminolgyID = {
      airFilter: "6192",
      cabinAirFilter: "6832",
      fuelFilter: "6200,6216",
      transmissionFilter: "8600,10964",
      oilFilter: "5340"
    };

    if(collectionType){
      if(collectionType == "air_filter"){
        return partTerminolgyID.airFilter;
      }
      else if(collectionType == "cabin_air_filter"){
        return partTerminolgyID.cabinAirFilter;
      }
      else if(collectionType == "oil_filter"){
        return partTerminolgyID.oilFilter;
      }
      else if(collectionType == "transmission_filter"){
        return partTerminolgyID.transmissionFilter;
      }
      else if(collectionType == "fuel_filter"){
        return partTerminolgyID.fuelFilter;
      }
      else{
        return "0";
      }
    }
    else{
      return "0";
    }

  }

  // global functions

function isJsonString(str) {
  try {
      JSON.parse(str);
  } catch (e) {
      return false;
  }
  return true;
}

function determineDataType(data) {
    if (typeof data === 'string' && isJsonString(data)) {
        return 'JSON string';
    } else if (typeof data === 'object' && data !== null) {
        return 'JavaScript object';
    } else {
        return 'Unknown type';
    }
}

  $('#classic-search-container').attr('data-filteroptions', $('#classic-search-container select:visible').length);  

  if($('body').hasClass('template-collection')){
    localStorage.setItem('backButtonHistoryfromPDP',window.location.href);
  }


  if(URLValuesForDynamicSearch != '' && URLValuesForDynamicSearch != undefined){
    setTimeout(function(){
      $('#dynamic-search').val(decodeURIComponent(URLValuesForDynamicSearch)).trigger('keyup');  
      var waitforDSresult = setInterval(function(){
         //console.log('WaitforResult');
        if($(document).find('#dynamic-search-results li').length > 0){
          // $(document).find('#dynamic-search-results li[data-value="'+URLValuesForDynamicSearch+'"]').trigger('click');  
          clearInterval(waitforDSresult);
        }        
      },0)
    },1000);    
  }
  if(URLValuesForVINSearch != '' && URLValuesForVINSearch != undefined){
    // let URLValuesForVINSearchKey = URLValuesForVINSearch.split('|')[0];
    // let URLValuesForVINSearchRegion = URLValuesForVINSearch.split('|')[1];
    setTimeout(function(){
      $('#vin-number').val(URLValuesForVINSearch);
      $('#btn-check-vin').trigger('click');
        // var waitforVINRegion = setInterval(function () {
        //   //console.log('waiting for VIN Region');
        //   if($('#vin-search-container select[name="RegionID"]').length > 0){
        //     $('#vin-search-container select[name="RegionID"]').val(URLValuesForVINSearchRegion).change();
        //     clearInterval(waitforVINRegion);
        //   }          
        // })
    },1000);
  }
  var URLParameter = {
    "termDuty": URLValues[0],
    "termYear": URLValues[1],
    "termMake": URLValues[2] != null ? decodeURIComponent(URLValues[2]) : undefined,
    "termModel": URLValues[3] != null ? decodeURIComponent(URLValues[3]) : undefined,
    "baseVehicleId": URLValues[4] != null ? decodeURIComponent(URLValues[4]) : undefined
  }
  let autoFill = false;
  let firstTime = true;
  
  // auto fill using session storage

  let classicSearch = sessionStorage.getItem("Classic_search");
	let productPage = sessionStorage.getItem("Product_page");
  let classicSearchData = null;
  try {
    classicSearchData = JSON.parse(sessionStorage.getItem("Classic_search_data"));
  } catch (e) {
    classicSearchData = null;
  }
  const homepageClassicSearch = sessionStorage.getItem("Homepage_Classic_search");
  const dataForRecommendation = sessionStorage.getItem("dataForRecommendation");

  let temp = productPage;
	if(productPage != null){
		productPage == null;
		sessionStorage.removeItem("Product_page");
	}
	
	if(classicSearch != null && window.location.href.includes("/products/")){
		sessionStorage.setItem("Product_page", "set");
	}
  else if(classicSearch != null && window.location.href.includes("/not-required/")){
		sessionStorage.setItem("Product_page", "set");
	}
	else if(classicSearch != null && classicSearchData && window.location.href == "https://highflow.com/search" && temp != null){
		URLParameter = {
      "termDuty": classicSearchData.duty,
      "termYear": classicSearchData.year,
      "termMake": classicSearchData.make,
      "termModel": classicSearchData.model,
      "baseVehicleId": classicSearchData.engine
    }
    autoFill = true;
		
	}
  else if(homepageClassicSearch != null && classicSearchData && window.location.href == "https://highflow.com/search"){
    // console.log("homepage search is set......");
    URLParameter = {
      "termDuty": classicSearchData.duty,
      "termYear": classicSearchData.year,
      "termMake": classicSearchData.make,
      "termModel": classicSearchData.model,
      "baseVehicleId": classicSearchData.engine
    }
    autoFill = true;
    homepageClassicSearch == null;
		sessionStorage.removeItem("Homepage_Classic_search");
  }
  else if(dataForRecommendation == null){
    const _showPopup = sessionStorage.getItem("offerPopup");
    // console.log("testing=====>>>>>",_showPopup )
		sessionStorage.clear();
    if(_showPopup){
      sessionStorage.setItem("offerPopup",true);
    }
  }

  // console.log(URLParameter);

  if(collectionPageURL.length > 1){
    const urlData = getCustomFilterData(getURL);
    // console.log("urldata", urlData)
    URLParameter = {
      "termDuty": urlData.VehicleTypeGroupID,
      "termYear": urlData.year,
      "termMake": decodeURIComponent(urlData.make),
      "termModel": decodeURIComponent(urlData.model)
    }

    // console.log("testing....", URLParameter)

    autoFill = true;

    if(URLParameter.termDuty != DEFAULT_DUTY){
      var checkTermDuty = setInterval(function(){
        if($('#termDuty option').length > 1){
          var collectionDuty = ensureTermDuty(URLParameter.termDuty);
          $('#termDuty').val(collectionDuty).change();
          // console.log('change checkTermDuty: ',URLParameter.termDuty)
          clearInterval(checkTermDuty);
        }
      },100)
    }
  }

  // console.log(URLParameter)

  // var isPageCollection = $('body').hasClass('template--collection');
  var isPageCollection = $('body').not('.template-step_new_1, .template-step_new_2, .template-step_new_3').hasClass('template--collection');
  if(getURL.indexOf('search?hpfilter') > -1){
    autoFill = true;
  }
  if(!isPageCollection){
    // Only apply URLParameter.termDuty when autoFill restored a search.
    // classicSearchData alone is NOT enough: on reload, Classic_search_data can still be
    // in memory while URLParameter was never restored, and assigning an invalid leftover
    // value (previously the full page URL from broken hpfilter parsing) cleared #termDuty.
    var preferredDuty = autoFill ? URLParameter.termDuty : null;
    if (autoFill && classicSearchData && classicSearchData.duty && !isValidDutyValue(preferredDuty)) {
      preferredDuty = classicSearchData.duty;
    }
    ensureTermDuty(preferredDuty);
    searchForYears();
  }
$(document).find('[data-selected-product-type]').text($('#termDuty option[value="'+ensureTermDuty($('#termDuty').val())+'"]').text());

    $(document).on('click', '#showAllCollectionProducts', function() {
      $('#ProductGridWrapper').show();
      $('#resetCollectionProducts, #showAllCollectionProducts').toggleClass('hidden');
    })

  $(document).on('click', '#resetCollectionProducts', function() {
      $('select[data-searchby-duty]').trigger('change');
      $('#ProductGridWrapper').show();
      $('#resetCollectionProducts, #showAllCollectionProducts').toggleClass('hidden');
    })


  $(document).on('focus','#classic-search-container .select2-container', function(){
    let getId = $(this).closest('.form-block').find('select').attr('id'); //console.log(getId);
      $('#'+getId).select2('open');
})

  //prefill make and model
  if(isPageCollection){
    //for make
    //let vl = $('#product-grid .prod--handle').attr('data-maketag');
    let vl_make = $('.product_collection').attr('data-make');
    
    /*let collTitle_make = $('.page-collections').attr('data-collection');
    collTitle_make = collTitle_make.replace(vl_make.toLowerCase(),'').trim();
    $('.page-collections').attr('data-collection',collTitle_make);*/
    
    let option_make = '<option data-label="'+vl_make+'" value="'+vl_make+'">'+vl_make+'</option>'
    $('select#termMake').append(option_make);
    $('select#termMake').val(vl_make).trigger('change');
    
    //for model
    let vl_model = $('.product_collection').attr('data-model');    
    let option_model = '<option data-label="'+vl_model+'" value="'+vl_model+'">'+vl_model+'</option>'
    $('select#termModel').append(option_model)    
    $('select#termModel').val(vl_model).trigger('change');
    
  }
  
  if($('body').hasClass('template-step_new_2') || $('body').hasClass('template-step_new_3')){
    let duty = ensureTermDuty($('select[data-searchby-duty]').val());
    newSearchResult(duty, "", "", "", "", "");
  } 
  $('select[data-searchby-duty]').on('change', function(){
    //console.log('duty change hit');
    let itemEle = $(this);
    let itemIndex = $(this).index(); 
    let duty = ensureTermDuty($(this).val());
    let currentSelector = itemEle.context.id;
    $('#ProductGridContainer').hide();
    resetSearchFields(itemIndex, itemEle)
    if($('body').hasClass('template-step_new_2') || $('body').hasClass('template-step_new_3')){
      newSearchResult(duty, "", "", "", "", "");
    } 
    if(duty!=''){
      searchForYears(duty);
    }
  })
  $('select[data-searchby-year]').on('change', function(){
    let itemEle = $(this); 
    // console.log('itemEle==>', itemEle.context.id);
    let itemIndex = $(this).index(); 
    // console.log('itemIndex=>', itemIndex);
    let currentSelector = itemEle.context.id;
    let duty = $('select[data-searchby-duty]').val();
    let year = $(this).val();
    $('#ProductGridContainer').hide();
    resetSearchFields(itemIndex, itemEle)
    if($('body').hasClass('template-step_new_2') || $('body').hasClass('template-step_new_3')){
      newSearchResult(duty, year, "", "", "", currentSelector);
    }    
    if(duty!='' && year != ''){
      searchForMake(duty, year, itemIndex, itemEle)
    }
  })
  $('select[data-searchby-make]').on('change', function(){
    //console.log('enter in change')
    let itemEle = $(this);
    let itemIndex = $(this).index();
    let currentSelector = itemEle.context.id;
    let make = $(this).val();
    let duty = $('select[data-searchby-duty]').val();
    let year = $('select[data-searchby-year]').val();
    $('select[data-searchby-model]').val('');
    $('select[data-searchby-engine]').val('');
    $('#ProductGridContainer').hide();
    resetSearchFields(itemIndex, itemEle)
    if($('body').hasClass('template-step_new_2') || $('body').hasClass('template-step_new_3')){
      newSearchResult(duty, year, make, "", "", currentSelector);
    } 
    if(duty != '' && year != '' && make != ''){
      ////console.log('thisIndex: ',itemIndex);
      searchForModel(duty, year, make, itemIndex, itemEle)
    }
    $('#dynamic-search, #vin-number').val('');
    $('#dynamic-search-container .form-block').not(':first').remove();
    if($('#vin-search-container .form-block').length > 1){
      $('#vin-search-container .form-block').not(':first').remove();
    }
  })
  $('select[data-searchby-model]').on('change', function(){
    // console.log('Enter in Model change event');
    let itemEle = $(this);
    let itemIndex = $(this).index();
    let currentSelector = itemEle.context.id;
    let model = $(this).val();
    let duty = $('select[data-searchby-duty]').val();
    let year = $('select[data-searchby-year]').val();
    let make = $('select[data-searchby-make]').val();
    $('select[data-searchby-engine]').val('');
    $('#ProductGridContainer').hide();
    resetSearchFields(itemIndex, itemEle)
    if($('body').hasClass('template-step_new_2') || $('body').hasClass('template-step_new_3')){
      newSearchResult(duty, year, make, model, "", currentSelector);
    } 
    if(duty != '' && make != '' && year != '' && model != ''){         
      //console.log('-11')
      searchForEngine(duty, year, make, model, itemIndex, itemEle);
    }
  })
  $('select[data-searchby-engine]').on('change', function(){
    // console.log('Enter in Engline change event');
    selectedQual = [];
    let itemEle = $(this);
    let itemIndex = $(this).index();
    let make = $('select[data-searchby-make]').val();
    let year = $('select[data-searchby-year]').val();
    let model = $('select[data-searchby-model]').val();
    let enginename = $(this).attr('data-enginename');
    let baseID = $(this).attr('data-basevehicleid');
    let engineID = $(this).val();
    $('#ProductGridContainer').hide();
    //resetSearchFields(itemIndex, itemEle)
    if(make != '' && year != '' && model != '' && baseID != '' && engineID != ''){           
      //console.log('-1')

      // if (!partNumbersExecuted) {
      //   partNumbersExecuted = true;
        searchForMoreSelect(itemIndex, itemEle, year, make, model, baseID, engineID)

        // console.log("inc", inc);
        //inc++;
      // }
      
      
      
      
    }
  })
  
  $(document).on('change', 'select.qualifier-select', function(){
    
    let itemEle = $(this);
    let itemIndex = $(this).index();
    let thisVal = $(this).val();
    let make = $('select[data-searchby-make]').val();
    let year = $('select[data-searchby-year]').val();
    let model = $('select[data-searchby-model]').val();
    let baseID = $('select[data-searchby-engine]').attr('data-basevehicleid');
    let engineID = $('select[data-searchby-engine]').val();
    
    $('#ProductGridContainer').hide();
    // console.log('changes on qualifier select option');
    // console.log(thisVal);
    // console.log("itemEle", itemEle.attr('id'));

    let valueToCheck = thisVal.split(':')[0];

    let valueChanged = false;

    for (let i = 0; i < selectedQual.length; i++) {
      if (selectedQual[i].includes(valueToCheck)) {
          // Replace the element with the new value if the key is found
          selectedQual[i] = `${itemEle.attr('id')}-${thisVal}`;
          valueChanged = true;
          break;
      }
    }

    if(valueChanged == false){
      selectedQual.push(`${itemEle.attr('id')}-${thisVal}`);
    }
    
    

    


    
    resetSearchFields(itemIndex, itemEle)
    // console.log("testing when pushed qual", selectedQual);
    if(make != '' && year != '' && model != '' && baseID != '' && engineID != ''){
      searchForMoreSelect(itemIndex, itemEle, year, make, model, baseID, engineID)
    }
  })

  $(document).on('keyup', '#dynamic-search', function(){
    // $('#classic-search-container select#termYear').val('').change();
    resetSearchFields(0, '#termYear');
    $('#classic-search-container select#termYear').val('').change();
    $('#vin-number').val('');
    if($('#vin-search-container .form-block').length > 1){
      $('#vin-search-container .form-block').not(':first').remove();
    }

    let thisEle = $(this);
    $('#dynamic-search-results').html('');
    $('#dynamic-search-results').removeClass('show');
    setTimeout(function(){
      let thisVal = thisEle.val();
      if(thisVal.length > 1){
          //console.log('done typing... partNumber Search');

          dynamicSearchQuery(thisVal);
      }
      else{     
        $('#dynamic-search-results').removeClass('show');
      }
    },1000)
  })
  
  $(document).on('click', '.template--search .brator-pagination-box .page-numbers', function(e){
    e.preventDefault();
    let thisURL = $(this).attr('href');
    ajaxPagination(thisURL)
  })
  
  /*###### Search For year #########*/
  function searchForYears(duty, itemIndex, itemEle){
    selectedQual = [];
    // console.log("duty==>: ",duty);
    if(duty == undefined || duty == null || duty === ''){
      duty = ensureTermDuty($('select[data-searchby-duty]').val());
    } else {
      duty = ensureTermDuty(duty);
    }
    $.ajax({
      type: "GET",
      url: `${yearCollection}/${duty}`,
      dataType: 'json',
      success: function(resData) {
        if(resData){ 
          let data = {};
          data.response = resData;
          let response = data.response;
          if(response.length > 0){
            // condition to remove year from drain plugs 
            if (window.location.href.includes("drain-plugs")) {
              response = response.filter(item => item.year !== 2025 && item.year !== 2026);
            }
            // console.log('response year:==> ',response);
            resetSearchFields(itemIndex, itemEle)
            let bindOption = "";
            for (let index = 0; index < response.length; index++) {
              bindOption += '<option data-label="'+response[index].label+'" value="'+response[index].year+'">'+response[index].year+'</option>'
            }
            $('select[data-searchby-year]').append(bindOption)
            $('select[data-searchby-year]').removeAttr('disabled');
            //bind data from url
            if(autoFill){
              $('#termYear').val(URLParameter['termYear']).change();
            } else if(!firstTime) {
              $('select#termYear').select2('open');
            }
            firstTime = false;
            setTimeout(function(){
              if(response.length == 1){
                //console.log("response.length ", response.length);
                $('select#termYear').val($('select#termYear option[data-label]').val()).trigger('change');
              }
              else if(!autoFill){
                //console.log('inside not autofilll');
                 $('select#termMake').select2({  
                    selectOnClose: false,
                    matcher:_matcher,
                    dropdownPosition: 'below'
                  });
                  if($('#termYear').val() != '' && !window.location.href.includes('/products/')) {
                    $('select#termMake').select2('open');
                  }
              }
            },500)
          }            
          else{
            //scroll to search result
            //scrollToResult();
            //$('#ProductGridContainer').show();
            $('#ProductGridContainer .search-heading').find('span').text("We're sorry, there is no HIGHFLOW® product available for your vehicle at this time.");
          }
        }
      }
    });    
  }

  /*###### Search For Make #########*/
  function searchForMake(duty, year, itemIndex, itemEle){
    selectedQual = [];
    $.ajax({
      type: "GET",
      url: `${makeCollection}/${duty}/${year}`,
      dataType: 'json',
      success: function(resData) {
        if(resData){
          let data = {};
          data.response = resData;
          let response = data.response;
          ////console.log('response: ',response);
          //if page is collection
          if(isPageCollection){
            //let vl = $('#product-grid .prod--handle').attr('data-maketag');
            let vl = $('.product_collection').attr('data-make');
            
            let collTitle = $('.page-collections').attr('data-collection');
            collTitle = collTitle.replace(vl.toLowerCase(),'').trim();
            $('.page-collections').attr('data-collection',collTitle);
            
            let option = '<option data-label="'+vl+'" value="'+vl+'">'+vl+'</option>'
            $('select[data-searchby-make]').append(option)
            setTimeout(function(){
              $('select#termMake').val(vl).trigger('change');
            },100)
          }
          else{
            if(response.length > 0){
              resetSearchFields(itemIndex, itemEle)
              for (let index = 0; index < response.length; index++) {
                let bindOption = '<option data-label="'+response[index].make+'" value="'+response[index].MakeID+'_'+response[index].make+'">'+response[index].make+'</option>'
                $('select[data-searchby-make]').append(bindOption)
              }
              $('select[data-searchby-make]').removeAttr('disabled');
              //bind data from url
              if(autoFill){
                ////console.log('autofill')
                $('#termMake').val(URLParameter['termMake']).change();
              }
              setTimeout(function(){
                if(response.length == 1){
                  ////console.log("response.length ", response.length);
                  $('select#termMake').val($('select#termMake option[data-label]').val()).trigger('change');
                }
                else if(!autoFill){
                  $('select#termMake').select2({  
                    selectOnClose: false,
                    matcher:_matcher,
                    dropdownPosition: 'below'
                  });
                  $('select#termMake').select2('open')
                }
              },500)
            }
            else{
              //$('#ProductGridContainer').show();
              $('#ProductGridContainer .search-heading').find('span').text("We're sorry, there is no HIGHFLOW® product available for your vehicle at this time.");
            }
          }
        }
      }
    });    
  }

  function _matcher(params, data){
            
                // If there are no search terms, return all of the data
            if ($.trim(params.term) === '') {
                return data;
            }

            // Do not display the item if there is no 'text' property
            if (typeof data.text === 'undefined') {
                return null;
            }

            // `params.term` should be the term that is used for searching
            // `data.text` is the text that is displayed for the data object
            if (data.text.toUpperCase().indexOf(params.term.toUpperCase()) == 0) {
                let modifiedData = $.extend({}, data, true);
                
                // You can return modified objects from here
                // This includes matching the `children` how you want in nested data sets
                return modifiedData;
            }

            // Return `null` if the term should not be displayed
            return null;
        }

  // $('select#termMake').select2({
  //   matcher: matchStart
  // });
 
  /*###### Search For Model #########*/
  function searchForModel(duty, year, make, itemIndex, itemEle){
    selectedQual = [];
    const _make = make.split('_');
    const makeId = _make[0];
    $.ajax({
      type: "GET",
      url: `${modelCollection}/${duty}/${year}/${makeId}`,
      dataType: 'json',
      success: function(resData) {
        if(resData){
          let data = {};
          data.response = resData;
          let response = data.response;
          ////console.log('response: ',response)
          //if page is collection          
          if(isPageCollection){
            //let vl = $('#product-grid .prod--handle').attr('data-modeltag');
            let vl = $('.product_collection').attr('data-model');
            
            let collTitle = $('.page-collections').attr('data-collection');
            collTitle = collTitle.replace(vl.toLowerCase(),'').trim();
            collTitle = collTitle.replaceAll(' ','_');
            $('.page-collections').attr('data-collection',collTitle);
            
            let option = '<option data-label="'+vl+'" value="'+vl+'">'+vl+'</option>'
            $('select[data-searchby-model]').append(option)
            setTimeout(function(){
              $('select#termModel').val(vl).trigger('change');
            },100)
          }
          else{
            if(response.length > 0){
              resetSearchFields(itemIndex, itemEle)
              let bindOption = '';
              for (let index = 0; index < response.length; index++) {
                bindOption += '<option data-label="'+response[index].model+'" value="'+response[index].BaseVehicleID+'_'+response[index].model+'">'+response[index].model+'</option>';
              }
              $('select[data-searchby-model]').append(bindOption)
              $('select[data-searchby-model]').removeAttr('disabled');
              //bind data from url
              if(autoFill){
                $('#termModel').val(URLParameter['termModel']).change();
              }
              //trigger if only one option in select  
              setTimeout(function(){
                if(response.length == 1){
                  ////console.log("response.length ", response.length);
                  $('select#termModel').val($('select#termModel option[data-label]').val()).trigger('change');
                  //$('select#engineBaseId').change();
                }
                else if(!autoFill){
                    $('select#termModel').select2({  
                    selectOnClose: false,
                    matcher:_matcher,
                    dropdownPosition: 'below'
                  });
                  
                  $('select#termModel').select2('open');
                }
              },500)
            }
            else{
              //scroll to search result
              //scrollToResult();
              //$('#ProductGridContainer').show();
              $('#ProductGridContainer .search-heading').find('span').text("We're sorry, there is no HIGHFLOW® product available for your vehicle at this time.");
            }
          }
        }
      }
    });    
  }

  /*###### Search For Engine #########*/
  function searchForEngine(duty, year, make, model, itemIndex, itemEle){
    selectedQual = [];
    const _model = model.split('_');
    const baseVehicleID = _model[0];
    $.ajax({
      type: "GET",
      url: `${engineCollection}/${baseVehicleID}`,
      dataType: 'json',
      success: function(resData) {
        //console.log('enter in Engine Search==>', data);
        if(resData){
          let data = {};
          data.name = "engine";
          data.baseVehicleId = baseVehicleID;
          data.response = resData;
          let response = data.response;
          // console.log('response====>: ',response.length)
          if(data.name == 'part_numbers'){
            let make = $('select[data-searchby-make]').val();
            let year = $('select[data-searchby-year]').val();
            let model = $('select[data-searchby-model]').val();
            let engine = $('select[data-searchby-engine]').val();
            let engineLabel = $('select[data-searchby-engine] option[value="'+engine+'"]').attr('data-label');            
            //console.log('SearchforEngine Response==>', engineLabel, '===',engine);
            //console.log('6');
            //console.log('Result from Classic Search 222');
            partNumbers(data, year, make, model, engine, engineLabel);
            
          }
          else{
            //console.log('response Length==>', response.length);
            if(response.length > 0){
              resetSearchFields(itemIndex, itemEle)
              let bindOption = '';
              for (let index = 0; index < response.length; index++) {
                bindOption += '<option data-label="'+response[index].engine+'" value="'+response[index].EngineConfigID+'_'+response[index].engine+'">'+response[index].engine+'</option>'
              }
              $('select[data-searchby-engine]').append(bindOption);
              $('select[data-searchby-engine]').attr({'data-name' : data.name, 'data-baseVehicleId' : data.baseVehicleId}).removeAttr('disabled');
              //console.log('eeee', autoFill, URLParameter['engineBaseId'])
              if(autoFill && URLParameter['baseVehicleId'] != undefined){
                $('select#engineBaseId option[value="'+URLParameter['baseVehicleId']+'"]').prop('selected', true).change();
                // $('#engineBaseId').val(URLParameter['engineBaseId']).change();
                
              }
              //trigger if only one option in select  
              if(response.length == 1){
                  $('#ProductGridContainer').find('.search-product-list').html('');
                  //console.log("response.length ", response.length);
                  $('select#engineBaseId').val($('select#engineBaseId option[data-label]').val()).change();
              }
              else{
                let checkSelectVal = setInterval(function(){
                  if($('select#engineBaseId').val() == '' && $(document).find('.qualifier-select').length == 0){
                    $('select#engineBaseId').select2({  
                    selectOnClose: false,
                    matcher:_matcher,
                    dropdownPosition: 'below'
                  });
                    $('select#engineBaseId').select2('open');
                      clearInterval(checkSelectVal)
                    }
                },200)
              }
            }
            else{
              
              //console.log('Else part of reponse length 0');
              if(make != '' && year != '' && model != ''){
                  searchForMoreSelect(itemIndex, itemEle, year, make, model, '', '')
                }
              $('#engineBaseId').hide();
              //scroll to search result
              //scrollToResult();
              $( '#ProductGridContainer .search-product-list').html('');
              //$('#ProductGridContainer').show();
              $('#ProductGridContainer .search-heading').find('span').text("We're sorry, there is no HIGHFLOW® product available for your vehicle at this time.");              
               if($('body').hasClass('template--index') == false ){
                // console.log('333')                     
                  // window.location.href = '/pages/not-available-in-highflow';
                  localStorage.setItem("notrequiedmake", make);
                  localStorage.setItem("selectedMakenpf", make);
                  localStorage.setItem('selectedModel', model);
                  localStorage.setItem('selectedYearnpf', year);
                }
            
            }
          }
        }
      }
    });    
  }

  let tempQualifierVar = 0;
  let qualifierDataAll;
  let singleQualifierData;
  let _singleQualifierData;

  /*###### Search For MoreSelect #########*/
  async function searchForMoreSelect(itemIndex, itemEle, year, make, model, baseID, engineID){
    // console.log('Inside Search for More select==>');
    // resetSearchFields(itemIndex, itemEle)
    //console.log('Enter in MoreSelect options==>');
    ////console.log("baseID: ",baseID);
    ////console.log("engineID: ",engineID);
    let isHomeSearch = false;
    const tempMake = make.split('_');
    const tempModel = model.split('_');
    const tempEngine = engineID.split('_')
    const qualifierEngine = tempEngine[0];
    let qualifierOrPartNumberURL;


    const collectionType = $('.page-collections').attr('data-collection');
    let partTermID = getPartTerminolgyID(collectionType);

    // console.log("selected qualifiers", selectedQual);

    if(selectedQual.length == 0){
      let qualifierCheckURL = `${API_BASE_URL}/qualifiersforAllPartTypes/${baseID}/${qualifierEngine}/noqualifier/${partTermID}/0`;
      let testQualifiers = await fetch( qualifierCheckURL ,{
        method:"GET",
        mode:"cors",
      }).then(async response => {
          return await response.json();
      }).then(json => {
          return json;
      });

      
      if(testQualifiers == "fail"){
        qualifierOrPartNumberURL = `${API_BASE_URL_HIGHFLOW}/productList/${baseID}/${tempEngine[0]}/noqualifier/noqualifier`;
      }
      else if(testQualifiers.name?.length != 0 && testQualifiers.values?.length != 0){
        qualifierOrPartNumberURL = qualifierCheckURL;
        
      }
      else{
        qualifierOrPartNumberURL = `${API_BASE_URL_HIGHFLOW}/productList/${baseID}/${tempEngine[0]}/noqualifier/noqualifier`;
        
      }
    }
    else if(selectedQual.length > 0){

      const _len = selectedQual.length - 1;
      const __tempVal = selectedQual[_len];
      const _tempVal = __tempVal.split('-');
      const currentQualifier = _tempVal ? _tempVal[1].split('_') : [];
      const qualifierID = encodeURIComponent(currentQualifier[0]);
      const qualifierName = encodeURIComponent(currentQualifier[1]);

      let allQualifiers = [];

      selectedQual.forEach(item => {
        let parts = item.split('-'); 
        allQualifiers.push(parts[1]);
      });
      
      let arrayQualID = [];
      let arrayID = [];
      let arrayQualNames = [];

      allQualifiers.forEach(item => {
        let parts = item.split('_');
        arrayQualID.push(parts[0]);
        if(parts[1] == "N/A"){
          arrayQualNames.push("NA");
        }
        else{
          arrayQualNames.push(parts[1]);
        }
      });

      arrayQualID.forEach(item => {
        let parts = item.split(':');
        arrayID.push(parts[1]);
      });

      let _encodedQualNames = arrayQualNames.map(name => name.includes('/') ? name.replace(/\//g, '') : name);
      let encodedQualNames = _encodedQualNames.map(item => encodeURIComponent(item));
      let encodedQualId = arrayQualID.map(item => encodeURIComponent(item));
      


      let qualId = arrayQualID.length > 1 ? arrayQualID.join(',') : arrayQualID[0] || '';
      let _id = arrayID.length > 1 ? arrayID.join(',') : arrayID[0] || '';
      let qualNames = encodedQualNames.length > 1 ? encodedQualNames.join(',') : encodedQualNames[0] || '';
      let _encodedQualId = encodedQualId.length > 1 ? encodedQualId.join(',') : encodedQualId [0] || '';

      // console.log("qual NAmes", qualNames);
      let qualifierCheckURL = `${API_BASE_URL}/qualifiersforAllPartTypes/${baseID}/${qualifierEngine}/${qualId}/${partTermID}/0`;
      let testQualifiers = await fetch( qualifierCheckURL ,{
        method:"GET",
        mode:"cors",
      }).then(async response => {
          return await response.json();
      }).then(json => {
          return json;
      });
      if(testQualifiers.values == 0){
        qualifierOrPartNumberURL = `${API_BASE_URL}/productList/${baseID}/${tempEngine[0]}/${_encodedQualId}/${qualNames}`;
      }
      else if(testQualifiers.name?.length != 0 && testQualifiers.values.length != 0){
        qualifierOrPartNumberURL = qualifierCheckURL;
      }
    }

    
    if(itemEle.closest('.homepage-search').length > 0){
      isHomeSearch = true;
    }
    ////console.log("isHomeSearch: ",isHomeSearch)
      
      let data = {termYear: year, termMake: tempMake[1]? tempMake[1] : "", termModel: tempModel[1] ? tempModel[1] : "", "baseVehicleId": baseID , "engineBaseId": tempEngine[0] ? tempEngine[0] : ""};  
      let mainData = data;
      // console.log("data", data);
    /*if(keyIDName != '' && keyIDName != undefined){
      data = {termYear: year, termMake: make, termModel: model, "baseVehicleId": baseID , "engineBaseId": engineID, [keyIDName]: keyIDValue}
    }*/

    if(isHomeSearch){
      let duty = $('select[data-searchby-duty]').val();
      sessionStorage.setItem("Homepage_Classic_search", "set");
      sessionStorage.setItem("Classic_search_data", JSON.stringify({
        duty: duty,
        year: year,
        make: make,
        model:model,
        engine: engineID
      }));
      //console.log('INhomepage send data==>', baseID,'===',engineID);
      let searchLink = "/search?"+year+","+make+","+model+","+baseID+","+engineID+"";
      if(engineID =='' || engineID == undefined){
        let searchLink = "/search?hpfilter="+duty+","+year+","+make+","+encodeURIComponent(model)+"";  
        $('#the-forid').attr('href',searchLink);
        window.location.href = "/search";
      }else {
        let searchLink = "/search?hpfilter="+duty+","+year+","+make+","+model+","+encodeURIComponent(engineID)+"";  
        $('#the-forid').attr('href',searchLink);
        window.location.href = "/search";
      }

      
    }
    let prodceed = true;
    if($(document).find('select.custom-select.qualifier-select').length > 0){
        $('select.custom-select.qualifier-select').each(function() {
          let thisVal = $(this).val();
          let keyIDName = $(this).attr('data-searchby');
          let keyIDValue = $(this).find("option[value='"+thisVal+"']:selected").attr('data-keyid');
          if(thisVal == ''){
            prodceed = false;
          }
          data[keyIDName] = keyIDValue;
        })
    }

    //pass category type in API to get only selected data in collection pages from AutoComplete

    const collectionPageURL = window.location.href;

    if(collectionPageURL.includes('/collections/')){
      data.categoryType = collectionType;
    }
    
    //console.log("this data ===>>>", data);
    if(prodceed && !isHomeSearch){
      $.ajax({
      type: "GET",
      url: qualifierOrPartNumberURL,
      dataType: 'json',
      success: function(resData) {
        // console.log("qual data", resData);
        // console.log("myData", data)
        if(resData){
          let data = {};
          data.response = resData.values;
          const resName = resData?.values ? resData?.values[0]?.id.split(':') : "";
          data.name = resName ? resName[0] : "";
          let response = data.response;
          // console.log('Get More options==>', response);
          // console.log('Get More options==>', response.length);

          if(resData.partTypeArray != undefined){
            // const mergedPartNumbersArray = [].concat(resData.partTypeArray, resData.CapsAndPlugsArray, resData.WiperBlades, resData.Fluids);
            const mergedPartNumbersArray = [].concat(resData.partTypeArray, resData.WiperBlades);
            data.response = mergedPartNumbersArray;
            data.name = "part_numbers";
            // console.log("merged Array", mergedPartNumbersArray);
          }

          NSData = data;
          
          let keyName = '';
          let responseName = '';
          if(data.name == 'part_numbers'){    
            let duty = $('select[data-searchby-duty]').val();        
            let make = $('select[data-searchby-make]').val(); //console.log('makevalue==>', make);
            let year = $('select[data-searchby-year]').val(); //console.log('yearvalue==>', year);
            let model = $('select[data-searchby-model]').val(); //console.log('modelvalue==>', model);
            let engine = $('select[data-searchby-engine]').val(); //console.log('enginevalue==>', engine)
            let engineLabel = $('select[data-searchby-engine] option[value="'+engine+'"]').attr('data-label'); //console.log('engineLabelvalue==>', engineLabel);            
            
            const _engineLabel = tempEngine[1];

            partNumbers(data, mainData.termYear, mainData.termMake, mainData.termModel, mainData.engineBaseId, _engineLabel, isHomeSearch)
            // console.log('function-calling test 2');
          //localStorage.setItem('backButtonHistoryfromPDP', '/search?hpfilter='+duty+','+year+','+make+','+model+','+engine+','+engineLabel);
           localStorage.setItem('backButtonHistoryfromPDP', '/search');
           if(!isHomeSearch && window.location.href == "https://highflow.com/search"){
            sessionStorage.setItem("Classic_search", "set");
            sessionStorage.setItem("Classic_search_data", JSON.stringify({
                duty: duty,
                year: year,
                make: make,
                model:model,
                engine: engine,
                engineLabel: engineLabel
              }));
           }
          }
          else{
            //console.log('Else Part of more Search==>');
            //if this is not homepage search
            // const aliasObj = {"AspirationID":"Aspiration","BedLengthID":"Bed Length","BedTypeID":"Bed Type","BodyNumDoorsID":"Body Num Doors","BodyTypeID":"Body Type","BrakeABSID":"Brake ABS","BrakeSystemID":"Brake System","CylinderHeadTypeID":"Cylinder Head Type","DriveTypeID":"Drive Type","EngineBaseID":"Engine Base","EngineDesignationID":"Engine Designation","EngineVersionID":"Engine Version","EngineVINID":"Engine VIN","BrakeTypeID":"Brake Type","SpringTypeID":"Spring Type","FuelDeliverySubTypeID":"Fuel Delivery Sub Type","FuelDeliveryTypeID":"Fuel Delivery Type","FuelSystemControlTypeID":"Fuel System Control Type","FuelSystemDesignID":"Fuel System Design","FuelTypeID":"Fuel Type","IgnitionSystemTypeID":"Ignition System Type","MfrBodyCodeID":"Mfr Body Code","PowerOutputID":"Power Output","BrakeTypeID":"Brake Type","SpringTypeID":"Spring Type","RegionID":"Region","SteeringTypeID":"Steering Type","SteeringSystemID":"Steering System","SubModelID":"Sub Model","ElecControlledID":"Elec Controlled","TransmissionBaseID":"Transmission Base","TransmissionControlTypeID":"Transmission Control Type","MfrID":"Mfr","TransmissionMfrCodeID":"Transmission Mfr Code","TransmissionNumSpeedsID":"Transmission Num Speeds","TransmissionTypeID":"Transmission Type","ValvesID":"Valves","ValvesPerEngineID":"Valves Per Engine","VehicleTypeID":"Vehicle Type","WheelBaseID":"Wheel Base","EngineMfrID":"Engine Mfr"};
            if(!isHomeSearch){
              if(data.name){
                keyName = data.name;
                responseName = keyName.toLowerCase();
                aliasKeyName = aliasObj[''+keyName+''];
              }
              if(response.length > 0){
                resetSearchFields(itemIndex, itemEle)
                
                //select placeholder
                var loopCounter = 0;
                $('select[data-searchby-'+responseName+']').html('');
                let createSelect = '<div class="form-block more-search"><select data-placeholder="'+aliasKeyName+'" data-qualifier="true" id="'+responseName+'" data-label="'+keyName+'" data-searchby-'+responseName+' class="qualifier-select custom-select select-'+responseName+'" disabled></select></div>'
                $('.brator-parts-classic-search-box-form').append(createSelect);
                let bindOption = '';
                //console.log('before Bind Html==>', response.length)
                for (let index = 0; index < response.length; index++) {
                  loopCounter++
                  // console.log('index==>', index);
                  let item = response[index]; //console.log('item==>', item);
                  let _keyID = item.id.split(':');
                  let keyID = _keyID[1]; //console.log('KeyId==>', keyID);
                  if(keyID == undefined){
                    let objItem = item;
                    let itemKeys = Object.keys(objItem); //console.log('ItemKey==>', itemKeys)
                    for(let i = 0 ; i< itemKeys.length; i++){
                      //console.log('Inside for loop==>', i,'===>', itemKeys[i]);
                        if(itemKeys[i].indexOf('ID') > -1 || itemKeys[i].indexOf('Id') > -1){
                          if(itemKeys[i] != undefined){
                            let objItemKey = itemKeys[i];
                            keyID = item[objItemKey]
                          }
                        }
                    }
                  }

                  //console.log("compare loop==>", loopCounter, '====' , response.length)
                  //if(loopCounter == response.length){
                    bindOption += '<option data-label="'+response[index].values+'" data-keyname="'+aliasKeyName+'" data-keyid="'+keyID+'" value="'+item.id+'_'+item.values+'">'+item.values+'</option>';
                  //}
                  
                  //console.log("bindeed options", bindOption);
                }
                $(document).find('select[data-searchby-'+responseName+']').append(bindOption);
                $(document).find('select[data-searchby-'+responseName+']').attr('data-searchby',keyName).removeAttr('disabled'); 
                //trigger if only one option in select  
                //setTimeout(function(){
                  if(response.length > 0 && response.length == 1){
                    $('select#'+responseName+'').closest('.form-block').addClass('hidden');
                    //console.log("response.length ", response.length)
                    $('select#'+responseName+'').trigger('change');
                  }
                  else{
                    // console.log('Aliaskeyname', aliasKeyName, '===', keyName);
                    $(document).find('select[data-searchby-'+responseName+']').prepend('<option data-first="yo" value="" selected>'+aliasKeyName+'</option>');
                    let checkSelectVal = setInterval(function(){
                      if($('select#'+responseName+'').val() == ''){
                         $('select#'+responseName+'').select2({  
                            selectOnClose: false,
                            matcher:_matcher,
                            dropdownPosition: 'below'
                          });
                        $('select#'+responseName+'').select2('open');
                          clearInterval(checkSelectVal)
                        }
                    },300)
                    
                    // console.log("Qual......")
                    // console.log(tempQualifierVar);
                    qualifierDataAll = JSON.parse(sessionStorage.getItem("prequalifier"));
                    if(qualifierDataAll){
                      singleQualifierData = qualifierDataAll.prequalifier[tempQualifierVar];
                      if(singleQualifierData){
                        _singleQualifierData = singleQualifierData.split("-");
                      }
                      tempQualifierVar++;
                    }
                  }  
                  //$(document).find('select#'+responseName+'').select2();
                  $(document).find('select#'+responseName+'').select2().on('select2:open', function () {
                    var a = $(this).data('select2');
                    var placeholder = $(this).attr('data-placeholder');
                    if (!$('.select2-link').length) {
                      a.$results.parents('.select2-results').find('.custom-select2-label').remove();
                      a.$results.parents('.select2-results')
                        .prepend("<span class='custom-select2-label'>"+placeholder+"</span>")
                        .on('click', function (b) {
                        a.trigger('close');
                      });
                    }
                  });
               // },300)
              //  console.log("test=>",_singleQualifierData);

               if(autoFill && _singleQualifierData){
                //console.log("fill qualifiers.....")
                setTimeout(() => {
                  $(document).find('select#'+_singleQualifierData[0]+'').val(_singleQualifierData[1]).trigger("change");
                  $(document).find('select#'+_singleQualifierData[0]+'').select2('close');
                }, 500)
               }

              }
              else{
                //scroll to search result
                //scrollToResult();
                //$('#ProductGridContainer').show();
                $('#ProductGridContainer .search-heading').find('span').text("We're sorry, there is no HIGHFLOW® product available for your vehicle at this time.");
              }
            }

          }

          // if(isHomeSearch){
          //   //console.log('INhomepage send data==>', baseID,'===',engineID);
          //   let searchLink = "/search?"+year+","+make+","+model+","+baseID+","+engineID+"";
          //   let duty = $('select[data-searchby-duty]').val();
          //   if(engineID =='' || engineID == undefined){
          //     let searchLink = "/search?hpfilter="+duty+","+year+","+make+","+encodeURIComponent(model)+"";  
          //     $('#the-forid').attr('href',searchLink);
          //   }else {
          //     let searchLink = "/search?hpfilter="+duty+","+year+","+make+","+model+","+encodeURIComponent(engineID)+"";  
          //     $('#the-forid').attr('href',searchLink);
          //   }
            
            
          // }
        }
      }
    });
    }
  }

  function errorData(xhr, errorType, exception) {
    try {
      // console.log("try Response TExt", xhr.responseText);
      //responseText = jQuery.parseJSON(xhr.responseText);
      // $("#dialog").append("<div><b>" + errorType + " " + exception + "</b></div>");
      // $("#dialog").append("<div><u>Exception</u>:<br /><br />" + responseText.ExceptionType + "</div>");
      // $("#dialog").append("<div><u>StackTrace</u>:<br /><br />" + responseText.StackTrace + "</div>");
      // $("#dialog").append("<div><u>Message</u>:<br /><br />" + responseText.Message + "</div>");
  } catch (e) {
      responseText = xhr.responseText;
      // console.log('Catch', responseText);
      //$("#dialog").html(responseText);
  }
  }
  /*###### Search List of PartNumbers #########*/
  var partNumberLocalData = {};
  function partNumbers(data, year, make, model, engine, engineLabel){
    // console.log("part number data", data, year, make, model, engine, engineLabel);
    extractedValues = new Set();
    NSData = data;
    // selectedQual = [];

    
    //setting qualifiers in session storage
    // console.log("selectedQual", selectedQual);
    sessionStorage.setItem("prequalifier", JSON.stringify({
      'prequalifier': selectedQual
    }));
    
    //if(!isHomeSearch){
      showLoaderforProductGrid();
    //} 
    $(document).find('.col-prod-year-filter, .paginationfromyearapi').remove();
    $('#ProductGridContainer .search-product-list').html('');
    partNumberLocalData = {"data":data, "year": year, "make": make, "model": model, "engine": engine, "engineLabel": engineLabel};
    //$('.brator-cart-item-list-overlay').addClass('open');
    var getresult = data.response.length;
    let result = data.response;
    //let skuArrList = [];
    var searchProdList = '';
    let partNumberList = [];
    for(let i = 0; i< getresult; i++){
      partNumberList.push(result[i].partNumber);
    }
    
    let _collName = $('.page-collections').attr('data-collection');
    const _collectionPageURL = window.location.href;
    
    if(_collectionPageURL.includes('/collections/')){
      partNumberList.forEach(e => {
        if(e == "NR" || e == "NRC" || e == "NS" || e== "NSA" || e== "NSC" || e== "NSF" || e== "NRA" || e== "NRF" || e== "NRO" || e== "NRT" || e== "NSO" || e== "NST"){
          window.location.href="/pages/not-required?col="+_collName;
        }
      })
    }
    let postData = {
      "termYear": year,
      "termMake": make,
      "termModel": model,
      "partNumber": partNumberList.toString()
    }
  



    $.ajax({
        type: 'POST',
        url: getProductsURL,
        data: postData,
        crossOrigin: true,
        dataType: 'json',
        success: function (data) {
          // console.log('data ProductUrl: ',data);
          let response = data.response;
          // Exclude Febreze products from search results (do not render)
          response = response.filter(function(item) {
            return String(item.product_type || '').toLowerCase() !== 'febreze';
          });
          if(response.length > 0){
            //console.log('Result from Classic search 1111');
            updateSearchHeading("","",year,make,model,engineLabel);
            //$('#ProductGridContainer .search-heading').find('span').text(''+year+', '+make+', '+model+', '+engineLabel+'');

            var ajaxArr = [];  
              
            // console.clear();

            //sorting response
            function compare( a, b ) {
              if ( a.product_type < b.product_type ){
                return -1;
              }
              if ( a.product_type > b.product_type ){
                return 1;
              }
              return 0;
            }

            response.sort(compare);

            // response = prioritizePartNumber(response);

            // console.log('pranjal testing sorted response', response);

            // setting the responce data in local storage 

            sessionStorage.setItem('dataForRecommendation', JSON.stringify(response));
            
            //debugger;
          response.forEach(el => {
            $.ajax({type: "GET", 
            url: '/products/'+el.handle+'?view=getproductdata', 
            crossOrigin: true,
            success: function(data){
              ajaxArr.push(data);
              // console.log('shopify data', data)
            },
            error: function(){
             // errorData()
            } ,


          })
        

            //ajaxArr.push($.ajax({type: "GET", url: '/products/'+el.handle+'?view=getproductdata', crossOrigin: true}))
          });

          // NS products

          function compareNSData( a, b ) {
            if ( a.partTypeCategory < b.partTypeCategory ){
              return -1;
            }
            if ( a.partTypeCategory > b.partTypeCategory ){
              return 1;
            }
            return 0;
          }


          // commented NS and NR data as not to show on website anymore 

          NSData.response.sort(compareNSData);
          setTimeout(() => {
            NSData.response.forEach(_e => {
              if(_e.partNumber == "NSF" || _e.partNumber == "NS" || _e.partNumber == "NSA" || _e.partNumber == "NSO" || _e.partNumber == "NST"){
                ajaxArr.push(`<div class="product-search-item non-serviceable col-md-6 col-lg-4 col-xl-3 col-12" data-handle="non-serviceable"> <div class="search-single-product"><div data-resultsort data-collection="${_e.partTypeCategory}" class="prod--handle brator-product-single-item-area brator-product-single-item-area-NS splide__slide design-two pp-type-grid-area"><span class="pro-collection-type" data-tag="${_e.partTypeCategory}">${_e.partTypeCategory.replaceAll("_", " ")}</span><span class="pro-meta-qualifier">Non-Serviceable Filter</span><div class="brator-product-single-item-img"><a><img src="https://cdn.shopify.com/s/files/1/0649/1937/1990/files/Non-Serviceable_1.jpg?v=1701875734"></a></div></div></div></div>`);
              }
              else if(_e.partNumber == "NR" || _e.partNumber == "NRC" || _e.partNumber == "NRA" || _e.partNumber == "NRF" || _e.partNumber == "NRO" || _e.partNumber == "NRT"){
                let NRImage;
                NRImage = "https://cdn.shopify.com/s/files/1/0649/1937/1990/files/Not_Required.jpg?v=1702014035";
                ajaxArr.push(`<div class="product-search-item col-md-6 col-lg-4 col-xl-3 col-12" data-handle="not-required"> <div class="search-single-product"><div data-resultsort data-collection="${_e.partTypeCategory}" class="prod--handle brator-product-single-item-area brator-product-single-item-area-NS brator-product-single-item-area-NR splide__slide design-two pp-type-grid-area"><span class="pro-collection-type" data-tag="${_e.partTypeCategory}">${_e.partTypeCategory.replaceAll("_", " ")}</span><span class="pro-meta-qualifier">Not Required</span><div class="brator-product-single-item-img"><a href="/pages/not-required/?col=${_e.partTypeCategory}"><img src="${NRImage}"></a></div></div></div></div>`);
              }
            })
            
          }, 3000);

          // end 

          //console.log(ajaxArr)

            setTimeout(function(){
              $('#ProductGridContainer .search-product-list').html('')

            
            // console.log("ajaxArr===>",ajaxArr.length);
            // console.log("ajaxArr===>",ajaxArr);
            ajaxArr.forEach((ele,ind)=>{
              // console.log("elel==>", ele)
              $('#ProductGridContainer .search-product-list').append(ele);
            });
            // Scroll to results
            scrollToResult();
            $('#reset-filter-btn').removeClass('d-none');

            let itemsProcessedCheked = 0;
              // console.log('Response length==>', response.length);
              if(response.length > 1){
                response.forEach((elem, index) => {
                  //console.log(elem, '=====Response=======', index);
                  $('.search-product-list .product-search-item[data-handle="'+elem.handle+'"]').attr('data-sort', index);
                  itemsProcessedCheked++;
                   //console.log('itemsProcessed==>', itemsProcessed);
                   if(itemsProcessedCheked === response.length) {
                     var $wrapper = $('#ProductGridContainer .search-product-list');
                     $wrapper.find('.product-search-item').sort(function (a, b) {
                       return +a.dataset.sort - b.dataset.sort;
                   })
                   .appendTo( $wrapper);
                   }          
               });
              }


            
            
              let prodID = $(data).filter('.product-search-item').attr('data-id'); //console.log('prodID==>', prodID);
                  let prodLen = $('#ProductGridContainer .search-product-list .product-search-item[data-id="'+prodID+'"]').length;
                  $('#ProductGridContainer .search-product-list .product-search-item[data-id="'+prodID+'"]').attr('data-make', make)
                  if(!$('body').hasClass('template-step_new_2')){
                    //sortBasedOnTag();
                  }  
                  hideLoaderforProductGrid();

                  if(isPageCollection || $('body').hasClass('template-step_new_2') || $('body').hasClass('template-step_new_3') || $('body').hasClass('template-step_new_1')){
                    $('.prod--handle').closest('.product-search-item').hide();
                    setTimeout(function(){                        
                      let collName = $('.page-collections').attr('data-collection');
                      $('.prod--handle[data-collection="'+collName+'"]').closest('.product-search-item').show();
                      if($('body').hasClass('template-step_new_2') || $('body').hasClass('template-step_new_3') || $('body').hasClass('template-step_new_1')){
                        $('#ProductGridWrapper').hide();
                      }
                      //console.log('visibleproductleng==>', $('.prod--handle[data-collection="'+collName+'"]').closest('.product-search-item:visible').length)
                      if($('.prod--handle[data-collection="'+collName+'"]').closest('.product-search-item:visible').length == 0){
                        localStorage.setItem("notrequiedmake", make);
                        localStorage.setItem('selectedModel', model);
                        localStorage.setItem("selectedMakenpf", make);
                        localStorage.setItem('selectedYearnpf', year);

                        // Show inline message instead of redirect
                        if (typeof window.showNoProductsMessage === 'function') {
                          window.showNoProductsMessage();
                        } else {
                          window.location.href="/pages/not-available-in-highflow?col="+_collName;
                        }
                      }
                    },500)
                  }
                  let getColType = [];
                  $('.search-product-list > .product-search-item[data-handle]').each(function(){
                     getColType.push($(this).find('.pro-collection-type').text());
                    
                  })
                  var htmlForFilterType = ''
                  var filtercolType = [];
                  // console.log(getColType);
                  //console.log('getProductType==>', getColType.length, '====================', response.length);
                    let allproductLoaded = setInterval(function(){
                      // if(getColType.length === response.length){
                        // console.log('hi');
                        //console.log('Matching Length Matched==>')
                       
                      // }
                      setTimeout(function (params) {
                          clearInterval(allproductLoaded)
                        },2000)
                    },0);
              filtercolType = getColType.filter((v, i, a) => a.indexOf(v) === i);
                  setTimeout(function (params) {
                    $(document).find('#ProductGridContainer .col-prod-type-filter').remove();
                    
                    filtercolType = filtercolType.sort();
                  
                    // htmlForFilterType += '<div class="col-prod-type-filter"><span class="col-prod-type-filter-label label">Part Type: </span><div class="col-prod-type-filter-content-wrapper"><span class="col-prod-type-filter-selectedvalue mm">All</span><ul><li data-value="" class="selected"><input type="checkbox" data-value=""/>All</li>';
                    htmlForFilterType += '<div class="col-prod-type-filter"><span class="col-prod-type-filter-label label">Part Type: </span><span class="clear_search">Reset</span><div class="col-prod-type-filter-content-wrapper"><ul><li data-value=""><input id="all" type="checkbox"  data-value="" data-check="all" checked/><label for="all">All</label></li>';
                              for (let index = 0; index < filtercolType.length; index++) {
                             
                                htmlForFilterType += '<li data-value="'+filtercolType[index].replaceAll(' ', '_').toLowerCase()+'"><input id="'+filtercolType[index].replaceAll(' ', '_').toLowerCase()+'" type="checkbox"  data-value="'+filtercolType[index].replaceAll(' ', '_').toLowerCase()+'"/><label for="'+filtercolType[index].replaceAll(' ', '_').toLowerCase()+'">'+filtercolType[index]+'</label></li>';  
                              }
                            htmlForFilterType += '</ul></div></div>'
                        //console.log('dropdownHTML', htmlForFilterType)
                           $(document).find('#ProductGridContainer .product-dynamic-filter-row').append(htmlForFilterType);
                          })

        

}, 3000);

//custom speed change

          }
          else{
            //console.log('ererer')
            // $('#ProductGridContainer .search-heading').find('span').text("We're sorry, there is no HIGHFLOW® "+make+" available for your vehicle at this time.");
            $('#ProductGridContainer .search-heading').find('span').text("");
            if($('body').hasClass('template--index') == false ){   
              // console.log('111')         
                // Show inline message instead of redirect
                if (typeof window.showNoProductsMessage === 'function') {
                  window.showNoProductsMessage();
                } else {
                  window.location.href = '/pages/not-available-in-highflow?col='+_collName;
                }
            }
            localStorage.setItem("selectedMakenpf", make);
            localStorage.setItem("notrequiedmake", make);
            localStorage.setItem('selectedModel', model);
            localStorage.setItem('selectedYearnpf', year);
            // Don't scroll when showing no products message
            return;
          }
          
          //$('#ProductGridContainer').show();
          //scroll to search result
          //scrollToResult();
        },
        error: function (error) {
          //console.log("Error: ",error )
          $('#ProductGridContainer .search-heading').find('span').text("Were sorry, there is no HIGHFLOW® product available for your vehicle at this time.");
        }
      })
  }


/*######## Search with NewFilterResult API #############*/

// {​​​​​"key": "cabin_air_filter",
// "product_type": "vehicle_type_2",
// "year": 2020,
// "make": "acura",
// "model": "mdx"
// }

function newSearchResult(duty, year, _make, _model, _engine, currentSelector){
  let make = ""; 
  let model = "";
  let engine = "";
  if(_make){
    const tempMake = _make.split('_');
    make = tempMake[1];
  }

  if(_model){
    const tempModel = _model.split('_');
    model = tempModel[1];
  }
  if(_engine){
    const tempEngine = _engine.split('_');
    engine = tempEngine[1];
  }

  // Never build product_type with null/empty/invalid duty.
  duty = ensureTermDuty(duty);

  //if(!isHomeSearch){
    showLoaderforProductGrid();
  //}
  
  var newSearchResultAPI= 'https://highflow.pgiproduct.com/api/v2/common/newFilterSearch';
  var key = $('.page-collections').attr('data-collection');
  var currentCollection = $('.template-title-row .banner-title').text()
  if(key == "filter_caps"){
    key = "oil_filter_housing_cap";
  }
  // console.log('currentSelector', currentSelector);
  if(currentSelector == ''){
    var newAPIdata = {
      key: key,
      product_type: 'vehicle_type_'+duty+''
    }
  } else if(currentSelector == 'termYear'){
    var newAPIdata = {
      key: key,
      product_type: 'vehicle_type_'+duty+'',
      year: year
    }
  } else if(currentSelector == 'termMake'){
    var newAPIdata = {
      key: key,
      product_type: 'vehicle_type_'+duty+'',
      year: year,
      make: make
    }
  } else if(currentSelector == 'termModel'){
    var newAPIdata = {
      key: key,
      product_type: 'vehicle_type_'+duty+'',
      year: year,
      make: make,
      model: model
    }
  }
  

  function getAPIResponse(ajaxurl) { 
    return $.ajax({
      url: newSearchResultAPI,
      type: 'POST',
      dataType: 'json',
      data:newAPIdata
    });
  };

  async function renderAPIResult() {
    try {
      const responseList = await getAPIResponse(newSearchResultAPI);
      // console.log("Async await Result==>", responseList);    
      
      // $('#ProductGridContainer .search-heading').find('span').text(partNumber);
      //console.log("responsebyYear==>", responsebyYear.response.handles[0].data)
      if(responseList.response.data.length > 0){
        let partNumber = '';
      let getProductHandles = responseList.response.data; 
      // console.log("NewAPI product Handles==>", getProductHandles);
      let totalPageCount = responseList.response.total;
      // console.log("NewAPI count==>", totalPageCount);
      let pageDividedBy = responseList.response.per_page;
      let prevPageLink = responseList.response.prev_page_url;
      let lastPageLink = responseList.response.last_page_url;
      let firstPageLink = responseList.response.first_page_url;
      let nextPageLink = responseList.response.next_page_url;
      let currentPage = responseList.response.current_page;
      let lastPage = responseList.response.last_page;
      updateSearchHeading(currentCollection, duty, year, make, model, "")
        printProductfromYearAPIResponse(getProductHandles);
        setTimeout(function(){
          // console.log('Inside NewAPI delay');
          printPaginationfromYearAPIResponse(totalPageCount, pageDividedBy, firstPageLink, nextPageLink, lastPageLink, prevPageLink, currentPage, lastPage, partNumber );
         //$('#ProductGridContainer').show();
        },500);

      }else {
        //$('.search-product-list').removeClass('waiting-result');
        // $('.search-product-list').append('<center class="no-products-available">No Product Found</center>');
        $('.search-product-list').append('<center class="no-products-available"></center>');
        $('.brator-cart-item-list-overlay').removeClass('open');
        // Show inline message instead of redirect
        if (typeof window.showNoProductsMessage === 'function') {
          window.showNoProductsMessage();
        } else {
          window.location.href= "/pages/not-available-in-highflow";
        }
      }
    } catch(err) {
      // console.log(err);
    }
  }
  renderAPIResult();
}



  /*###### scroll to search result bottom #########*/
  // Keep the results area from collapsing into the footer while the list is cleared/reloaded.
  function pinResultsViewport() {
    var grid = document.getElementById('ProductGridContainer');
    if (!grid || grid.style.display === 'none') {
      window.scrollTo(0, 0);
      return;
    }
    var minH = Math.max(grid.offsetHeight, Math.round(window.innerHeight * 0.6));
    grid.style.minHeight = minH + 'px';
    var stickyFilter = document.querySelector('#classic-search-container.is-sticky');
    var offset = stickyFilter ? 350 : 250;
    var top = grid.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
  }

  function clearResultsMinHeight() {
    var grid = document.getElementById('ProductGridContainer');
    if (grid) grid.style.minHeight = '';
  }

  function scrollToResult(){    
    // Scroll to results with offset for sticky header/filter (skip on initial page load)
    if (!isInitialPageLoad) {
      setTimeout(function(){
        var stickyFilter = document.querySelector('#classic-search-container.is-sticky');
        var offset = stickyFilter ? 350 : 250;
        var element = document.getElementById('ProductGridContainer');
        if (element && element.style.display !== 'none') {
          var elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
          // Instant scroll — smooth from footer looks like a footer flash then jump.
          window.scrollTo({ top: Math.max(0, elementPosition - offset), behavior: 'auto' });
        }
        clearResultsMinHeight();
      }, 300);
    }
    isInitialPageLoad = false; // Set flag after first call
  }

  /*###### Dynamic search ############################################################*/
  let dynamicDataKeys = ["termYear", "termMake", "termModel", "engine"];
  let dynamicRequestData = {};
  function dynamicSearchQuery(query){
    
    dynamicRequestData = {};
    if($('#dynamic-search-container select').data('select2')) {
       $('#dynamic-search-container select').select2('destroy');
      $('#dynamic-search-container select').remove();
    }
    let data = {"term": query}
    $.ajax({
      type: 'GET',
      url: `${dynamicSearch}/${query}`,
      crossOrigin: true,
      success: function (response) {
        let data = JSON.parse(response);

        data.forEach(item => {
          if (item.id !== "label") {
              const idParts = item.id.split('!');
              const lastPart = idParts[idParts.length - 1];
              const valueParts = item.value.split('===');
              if(lastPart != "partnumber"){
                item.value = `${valueParts[0]}===${lastPart}===${valueParts[1]}`;
              }
              
          }
      });

      // console.log("converted data ==>", data);
        //console.log('DynamiceSearch data Length: ',data.length)
        //console.log('DynamiceSearch data ==>>: ',data)
        let bindOption = "";
        for (let index = 0; index < data.length; index++) {
          let dataLabel = data[index].label
          if(data[index].id != "label"){
            let dataID = data[index].value ? data[index].value : "";
            let dataHandle = data[index].id;
            let dataIdValue = data[index].id;
            // console.log("pranjal testing....", dataID);
            if(data[index].id == 'partnumber'){
              dataID = dataLabel;
            }
            dataID = dataID.toString();
            bindOption += '<li data-value="'+dataID+'" data-handle="'+dataHandle+'" data-idvalue="'+dataIdValue+'">'+dataLabel+'</li>';
          }
          else{
            bindOption += '<li class="label" data-value="'+dataLabel+'">'+dataLabel+'</li>';            
          }
        }
        setTimeout(function(){
          $('#dynamic-search-results').html('');
          $('#dynamic-search-results').append(bindOption);
          $('#dynamic-search-results').addClass('show');
          localStorage.setItem('backButtonHistoryfromPDP', '/search?dsfilter='+encodeURIComponent($('#dynamic-search').val()));
        },100)
      },
      error:  function (xhr, err) {
        //console.log('json error' + err.status );
      }
    });
  }

  $(document).on('click', '#dynamic-search-results li', function(){
    let partNumber = $(this).attr('data-value');
    let idValue = $(this).attr('data-idvalue');
    let thisText = $(this).text();
    $('#dynamic-search').val(thisText);
    $('#dynamic-search-results').removeClass('show');
    let _partNumber = partNumber.split('===');
    // console.log("_partNumber", _partNumber.length);
    //if partnumber contains year,make,model,engine etc...
    if(_partNumber.length > 2){
      partNumber = partNumber.split('===');
      vehichleInfo = partNumber[2];
      if(partNumber.length < 2){
        engineID = "";
      }
      else{
        // get year, make, model
        vehichleInfo = vehichleInfo.split('!');
        for(let i = 0; i < vehichleInfo.length; i++){
          if(i < dynamicDataKeys.length){
            dynamicRequestData[dynamicDataKeys[i]] = vehichleInfo[i]
          }
        }
        dynamicRequestData["baseVehicleId"] = partNumber[0];
        dynamicRequestData["engineBaseId"] = partNumber[1];
        ////console.log('dynamicRequestData: ',dynamicRequestData)
        //get qualifier
        getDynamicQualifier(dynamicRequestData, idValue);
      }
    }
    else{   
      getSingleProductByPartnumber(partNumber);
    }
  })

  $(document).on('change', '#dynamic-search-container select', function(){
    ////console.log("dynamicRequestData", dynamicRequestData);
    $(this).nextAll('select').remove();
    let thisVal = $(this).val();
    let clickedQualifier = $(this).attr('name');
      ////console.log('clickedQualifier',clickedQualifier)
      //alert('dynamicDataKeys[thisVal]', dynamicDataKeys[clickedQualifier])
    let checkQualifierExist = dynamicDataKeys[clickedQualifier] in dynamicRequestData;
    dynamicRequestData[clickedQualifier] = thisVal;
    /*if(checkQualifierExist == false){
      //console.log('thisVal', thisVal)
      //console.log('clickedQualifier', clickedQualifier)
      dynamicRequestData[clickedQualifier] = thisVal;
    }*/
    getDynamicQualifier(dynamicRequestData)
  })
  
  //get products using partnumber
  function getProductByPartnumber(partNumber){
    //console.log('INitial showcontianer2222'); 
    $(document).find('.col-prod-type-filter').remove();
    $('#ProductGridContainer .search-heading').find('span').text('');
    //if(!isHomeSearch){
      showLoaderforProductGrid();
    //}          
    $.ajax({
      type: 'GET',
      url: "/search?type=product&q=variants.sku:"+partNumber+"",
      crossOrigin: true,
      success: function (response) {

        if($(response).find('.search-single-product').length > 1){
          getYearAfterHitProductPartNumberAPI(partNumber);
          //console.log('Multiple Results 1');
          $('#ProductGridContainer .search-product-list').html('');
          let productList = $(response).find('#searchListResult').html();
          //$('#ProductGridContainer .search-product-list').append(productList);
          //$('#ProductGridContainer').show();
          //$('#ProductGridContainer .search-heading').find('span').text(partNumber);
          //scrollToResult();
        }
        else{
        //console.log('Single Results');
          let prodHandle = $(response).find('.prod---handle').attr('data-handle');
          ////console.log($(response).find('.prod---handle').attr('data-handle'))
          window.location.href = "/products/"+prodHandle+""
        }
      },
      error:  function (xhr, err) {
        //console.log('json error' + err.status );
      }
    });
  }  

  // get parent product using partnumber
  function getSingleProductByPartnumber(partNumber) {
    $(document).find('.col-prod-type-filter').remove();
    $('#ProductGridContainer .search-heading').find('span').text('');
    showLoaderforProductGrid();
    let data = {"sku": partNumber};
    $.ajax({
      type: 'POST',
      url: parentHandleAPI,
      data: {"sku" : partNumber,"token" : "aHQufUFucXNzZitSKUJMM3Fwa04="},
      dataType: 'json',
      crossOrigin: true,
      success: function (response) {
        if(response.status) {
          var pro_handle = response.response.handle;
          window.location.href = "/products/"+pro_handle;
        } else {
          window.location.href = "/products/"+partNumber+"";
        }
      },
      error:  function (xhr, err) {
        // console.log('json error' + err.status );
      }
    });
  }

  function ajaxPagination(thisURL){
    // Scroll to results first so clearing the list does not flash the footer.
    var grid = document.getElementById('ProductGridContainer');
    if (grid) {
      var top = grid.getBoundingClientRect().top + window.pageYOffset - 20;
      window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
    } else {
      window.scrollTo(0, 0);
    }

    $.ajax({
      type: 'GET',
      url: thisURL,
      crossOrigin: true,
      success: function (response) {
        ////console.log('Multiple Results 2');
        let productList = $(response).find('#searchListResult').html();
        let paginationHtml = $(response).find('.brator-pagination-box').first().prop('outerHTML');
        $('#ProductGridContainer .search-product-list').html(productList || '');
        if (paginationHtml) {
          var $pagination = $('#ProductGridContainer .brator-pagination-box');
          if ($pagination.length) $pagination.replaceWith(paginationHtml);
        }
        //$('#ProductGridContainer').show();
        $('#ProductGridContainer .search-heading').find('span').text();
        // Keep viewport on the product listing after results update.
        if (grid) {
          var afterTop = grid.getBoundingClientRect().top + window.pageYOffset - 20;
          window.scrollTo({ top: Math.max(0, afterTop), behavior: 'auto' });
        }
      },
      error:  function (xhr, err) {
        //console.log('json error' + err.status );
      }
    });
  }
  
  //get dynamic qualifier
  async function getDynamicQualifier(dynamicRequestData, searchValueId){

    const keysToExclude = ["termYear", "termMake", "termModel", "engine", "baseVehicleId", "engineBaseId"];
    

    for (const key in dynamicRequestData) {
        if (!keysToExclude.includes(key)) {
          extractedValues.add(dynamicRequestData[key]);
        }
    }
    let choosenQualValues = Array.from(extractedValues);

    // console.log("choosenQualValues",choosenQualValues);

    // console.log("testing for values", dynamicRequestData);

    let searchTermArr = searchValueId?.split('!');

    // let searchIDs = {
    //   year: searchTermArr[0],
    //   make: searchTermArr[1],
    //   model: searchTermArr[2],
    //   engine: searchTermArr[3]
    // }

    let dynamicQualifierOrPartNumberURL;

    // console.log("selectedDynQual", selectedDynQual);

    if(choosenQualValues.length == 0){
      let qualifierCheckURL = `${API_BASE_URL}/qualifiersforAllPartTypes/${dynamicRequestData.baseVehicleId}/${dynamicRequestData.engineBaseId}/noqualifier/0/0`;
      let testQualifiers = await fetch( qualifierCheckURL ,{
        method:"GET",
        mode:"cors",
      }).then(async response => {
          return await response.json();
      }).then(json => {
          return json;
      });

      
      if(testQualifiers == "fail"){
        dynamicQualifierOrPartNumberURL = `${API_BASE_URL_HIGHFLOW}/productList/${dynamicRequestData.baseVehicleId}/${dynamicRequestData.engineBaseId}/noqualifier/noqualifier`;
      }
      else if(testQualifiers.name?.length != 0 && testQualifiers.values?.length != 0){
        dynamicQualifierOrPartNumberURL = qualifierCheckURL;
        
      }
      else{
        dynamicQualifierOrPartNumberURL = `${API_BASE_URL_HIGHFLOW}/productList/${dynamicRequestData.baseVehicleId}/${dynamicRequestData.engineBaseId}/noqualifier/noqualifier`;
        
      }
    }
    else if(choosenQualValues.length > 0){

      const _len = choosenQualValues.length - 1;
      const __tempVal = choosenQualValues[_len];
      const currentQualifier = __tempVal ? __tempVal[1].split('_') : [];
      const qualifierID = encodeURIComponent(currentQualifier[0]);
      const qualifierName = encodeURIComponent(currentQualifier[1]);
      
      let arrayQualID = [];
      let arrayID = [];
      let arrayQualNames = [];

      choosenQualValues.forEach(item => {
        let parts = item.split('_');
        arrayQualID.push(parts[0]);
        arrayQualNames.push(parts[1]);
      });

      arrayQualID.forEach(item => {
        let parts = item.split(':');
        arrayID.push(parts[1]);
      });

      let encodedQualNames = arrayQualNames.map(item => encodeURIComponent(item));
      let encodedQualId = arrayQualID.map(item => encodeURIComponent(item));


      let qualId = arrayQualID.length > 1 ? arrayQualID.join(',') : arrayQualID[0] || '';
      let _id = arrayID.length > 1 ? arrayID.join(',') : arrayID[0] || '';
      let qualNames = encodedQualNames.length > 1 ? encodedQualNames.join(',') : encodedQualNames[0] || '';
      let _encodedQualId = encodedQualId.length > 1 ? encodedQualId.join(',') : encodedQualId [0] || '';

      let qualifierCheckURL = `${API_BASE_URL}/qualifiersforAllPartTypes/${dynamicRequestData.baseVehicleId}/${dynamicRequestData.engineBaseId}/${qualId}/0/0`;
      let testQualifiers = await fetch( qualifierCheckURL ,{
        method:"GET",
        mode:"cors",
      }).then(async response => {
          return await response.json();
      }).then(json => {
          return json;
      });
      // console.log("Came here", testQualifiers);
      if(testQualifiers.values == 0){
        // console.log("should come here.")
        dynamicQualifierOrPartNumberURL = `${API_BASE_URL}/productList/${dynamicRequestData.baseVehicleId}/${dynamicRequestData.engineBaseId}/${_encodedQualId}/${qualNames}`;
      }
      else if(testQualifiers.name?.length != 0 && testQualifiers.values.length != 0){
        dynamicQualifierOrPartNumberURL = qualifierCheckURL;
      }
    }


    $.ajax({
      type: 'GET',
      url: dynamicQualifierOrPartNumberURL,
      crossOrigin: true,
      success: function (resData) {

        // resData = JSON.parse(resData);

        let data = {}
        data.response = resData.values;
        const resName = resData?.values ? resData?.values[0]?.id.split(':') : "";
        data.name = resName ? resName[0] : "";
        // console.log("test", data);

        if(determineDataType(resData) == "JSON string"){
          resData = JSON.parse(resData);
        }

        // console.log(" testing data...", resData);
        // console.log(" testing data2...", data);
        if(resData.partTypeArray != undefined){
          // const mergedPartNumbersArray = [].concat(resData.partTypeArray, resData.CapsAndPlugsArray, resData.WiperBlades, resData.Fluids);
          const mergedPartNumbersArray = [].concat(resData.partTypeArray, resData.WiperBlades);
          data.response = mergedPartNumbersArray;
          data.name = "part_numbers";
          // console.log("inside merged array if")
          // console.log("merged Array", mergedPartNumbersArray);
        }

        
        ////console.log(data)
        if(data.name == "part_numbers"){
          let make = dynamicRequestData['termMake'];
          let year = dynamicRequestData['termYear'];
          let model = dynamicRequestData['termModel'];
          let engine = dynamicRequestData['engine'];
          let engineLabel = dynamicRequestData['engine'];
          //let engineLabel = $('select[data-searchby-engine] option[value="'+engine+'"]').attr('data-label');
          //console.log('3')
          //console.log('Result from Dynamic Search');
          // console.log("inside part number if")
          partNumbers(data, year, make, model, engine, engineLabel)
          
          localStorage.setItem('backButtonHistoryfromPDP', '/search?dsfilter='+encodeURIComponent($('#dynamic-search').val()));
        }
        else{
          //console.log('add More Dynamic Qualifiers');
          addDynamicQualifier(data)          
        }
      },
      error:  function (xhr, err) {
        //console.log('json error' + err.status );
      }
    });    
  }
  
  //add dynamic qualifier
  function addDynamicQualifier(data){

    // data = JSON.parse(data)
    let responseName;
    if(data.name){
      keyName = data.name;
      responseName = keyName.toLowerCase();
      aliasKeyName = aliasObj[''+keyName+''];
    }
    
    var hiddenBlock = false

      ////console.log('1')
    let response = data.response;
    if(response.length > 0 && response.length == 1){
     var hiddenBlock = true
    }
    if(response.length > 0){
      ////console.log('2')
      let qualifier = '';
      let keyName = data.name;
      for(let i = 0; i < response.length; i++){
        let obj = response[i];
        let keyID = obj[keyName];
        if(keyID == undefined){
          let objItem = response[i];
          let itemKeys = Object.keys(objItem)
          for(let i = 0 ; i< itemKeys.length; i++){
              if(itemKeys[i].indexOf('ID') > -1){
                if(itemKeys[i] != undefined){
                  let objItemKey = itemKeys[i];
                  keyID = obj[objItemKey]
                }
              }
          }
        }        
        ////console.log("keyName: ",keyName)
        qualifier += '<option data-label="'+response[i].values+'" value="'+response[i].id+'_'+response[i].values+'">'+response[i].values+'</option>'
      }

      let createQualifierSelect = '<select data-placeholder="'+aliasKeyName+'" name="'+keyName+'" class="custom-select"><option value="">'+aliasKeyName+'</option>'+qualifier+'</select>';
      $('#dynamic-search-container').append('<div class="form-block hidden">'+createQualifierSelect+'</div>');
      $(document).find('select[name="'+data.name+'"]').select2({
          placeholder: $(this).attr('data-placeholder')
      });
      
      
      //auto select if only 1 data in response      
      setTimeout(function(){
        // console.log('Select by qualifiere length=====>', response.length)
        if(response.length > 0 && response.length == 1){
        
          $('select[name="'+data.name+'"]').val($('select[name="'+data.name+'"] option[data-label]').val()).trigger('change');
        }
        else{
          $('select[name="'+data.name+'"]').closest('.form-block').removeClass('hidden');
          let checkSelectVal = setInterval(function(){
            if($('select[name="'+data.name+'"]').val() == ''){
               $('select#'+data.name+'').select2({  
                            selectOnClose: false,
                            matcher:_matcher,
                            dropdownPosition: 'below'
                          });
              $('select[name="'+data.name+'"]').select2('open');
              
                clearInterval(checkSelectVal)
              }
          },200)
        }                 
        $(document).find('select[name="'+data.name+'"]').select2().on('select2:open', function () {
          var a = $(this).data('select2');
          var placeholder = $(this).attr('data-placeholder');
          if (!$('.select2-link').length) {
            a.$results.parents('.select2-results').find('.custom-select2-label').remove();
            a.$results.parents('.select2-results')
              .prepend("<span class='custom-select2-label'>"+placeholder+"</span>")
              .on('click', function (b) {
              a.trigger('close');
            });
          }
        });
      },500)
    }
  }

  // GET API after hit pagination  getproductbypartNumber
  //https://high.pgiproduct.com/search/api/v2/common/getYearList?sku=PC4313X
  function getYearAfterHitProductPartNumberAPI(partNumber, pageNumber){
    if(pageNumber != undefined || pageNumber != ''){
      var apiUrl= "https://high.pgiproduct.com/search/api/v2/common/getYearList?sku="+partNumber+"&page="+pageNumber+"";
    }else{
      var apiUrl= "https://high.pgiproduct.com/search/api/v2/common/getYearList?sku="+partNumber+"";
     }
    $.ajax({
      type: 'GET',
      url: apiUrl,
      crossOrigin: true,
      success: function (responsebyYear) {
        $('#ProductGridContainer .search-heading').find('span').text(partNumber);
        //console.log("responsebyYear==>", responsebyYear.response.handles[0].data)
        let getProductHandles = responsebyYear.response.handles[0].data;
        let getYearsList = responsebyYear.response.year; // console.log("getYearsList Len==>", getYearsList.length);
        let totalPageCount = responsebyYear.response.handles[0].total;
        let pageDividedBy = responsebyYear.response.handles[0].per_page;
        let prevPageLink = responsebyYear.response.handles[0].prev_page_url;
        let lastPageLink = responsebyYear.response.handles[0].last_page_url;
        let firstPageLink = responsebyYear.response.handles[0].first_page_url;
        let nextPageLink = responsebyYear.response.handles[0].next_page_url;
        let currentPage = responsebyYear.response.handles[0].current_page;
        let lastPage = responsebyYear.response.handles[0].last_page;
          printProductfromYearAPIResponse(getProductHandles);
          printPaginationfromYearAPIResponse(totalPageCount, pageDividedBy, firstPageLink, nextPageLink, lastPageLink, prevPageLink, currentPage, lastPage, partNumber )
          if(getYearsList.length > 0){
            $('#ProductGridContainer').attr('data-sliderbar-enable', true);
            printYearDropdownfromYearAPIResonse(getYearsList);
          }
          
      },
      error:  function (xhr, err) {
        //console.log('json error' + err );
        //console.log('json erro===>', xhr);
      }
    });
  }  


  // POST API after hit pagination

  function getProductsAfterHitPagniationWithNewFilter(key, duty, year, make, model, pageNumber){   
      var apiUrl= "https://highflow.pgiproduct.com/api/v2/common/newFilterSearch?page="+pageNumber+"";

      if(key == "filter_caps"){
          key = "oil_filter_housing_cap";
      }

      duty = ensureTermDuty(duty);

        if(key !='' && duty !='' && year !='' && make!='' && model != ''){
          var newAPIdata = {
            key: key,
            product_type: 'vehicle_type_'+duty+'',
            year: year,
            make: make,
            model: model
          }
        } else if(key !='' && duty !='' && year !='' && make !='' && model == ''){
          var newAPIdata = {
            key: key,
            product_type: 'vehicle_type_'+duty+'',
            year: year,
            make: make
          }
        } else if(key !='' && duty !='' && year !='' && make =='' && model == ''){
          var newAPIdata = {
            key: key,
            product_type: 'vehicle_type_'+duty+'',
            year: year
          }
        } else if(key !='' && duty !='' && year =='' && make =='' && model == ''){
          var newAPIdata = {
            key: key,
            product_type: 'vehicle_type_'+duty+''
          }
        }
    
    $.ajax({
      type: 'POST',
      url: apiUrl,
      data: newAPIdata,
      crossOrigin: true,
      success: function (oldRes) {
        //$('#ProductGridContainer .search-heading').find('span').text(partNumber);
        let res = JSON.parse(oldRes);
        // console.log("responsebyYear==>", res.response.data)
        let getProductHandles =res.response.data;
        //let getYearsList = responsebyYear.response.year; console.log("getYearsList Len==>", getYearsList.length);
        let totalPageCount = res.response.total;
        let pageDividedBy = res.response.per_page;
        let prevPageLink = res.response.prev_page_url;
        let lastPageLink = res.response.last_page_url;
        let firstPageLink = res.response.first_page_url;
        let nextPageLink = res.response.next_page_url;
        let currentPage = res.response.current_page;
        let lastPage = res.response.last_page;
          printProductfromYearAPIResponse(getProductHandles);
          printPaginationfromYearAPIResponse(totalPageCount, pageDividedBy, firstPageLink, nextPageLink, lastPageLink, prevPageLink, currentPage, lastPage, "" )
          // setTimeout(function(){
          //   $('html,body').animate({
          //     scrollTop: $("#ProductGridContainer").offset().top - 50
          //    },2000);
          // },1000);
          //if(getYearsList.length > 0){
            //$('#ProductGridContainer').attr('data-sliderbar-enable', true);
            //printYearDropdownfromYearAPIResonse(getYearsList);
          //}
          
      },
      error:  function (xhr, err) {
        //console.log('json error' + err );
        // console.log('json erro===>', xhr);
      }
    });
  }  



  

  // Print Products from Year API Response
  function printProductfromYearAPIResponse(getProductHandles){
    
        //console.log('data ProductUrl: ',getProductHandles);
        let response = getProductHandles;
        if(response.length > 0){  
          //console.log('INitial showcontianer'); 
          $('#ProductGridContainer .search-product-list ').html('');    
          var ajaxArr = [];    
          // response.forEach(el => {
          //   ajaxArr.push($.ajax({type: "GET", url: '/products/'+el.handle+'?view=getproductdata', crossOrigin: true}))
          // });
          
          response.forEach(el => {
            $.ajax({type: "GET", 
            url: '/products/'+el.handle+'?view=getproductdata', 
            crossOrigin: true,
            success: function(data){
              ajaxArr.push(data);
            },
            error: function(){
             // errorData()
            } 
          })

            //ajaxArr.push($.ajax({type: "GET", url: '/products/'+el.handle+'?view=getproductdata', crossOrigin: true}))
          });


            setTimeout(function(){
              $('#ProductGridContainer .search-product-list').html('');
              ajaxArr.forEach((ele,ind)=>{
                //console.log("elel==>", ind)
                $('#ProductGridContainer .search-product-list').append(ele);
                
              })
              // Scroll to results
              scrollToResult();
              itemsProcessed = 0;
              // console.log('Response length==>', response.length);
              if(response.length > 1){
                response.forEach((elem, index) => {
                  //console.log(elem, '=====Response=======', index);
                  $('.search-product-list .product-search-item[data-handle="'+elem.handle+'"]').attr('data-sort', index);
                   itemsProcessed++;
                   //console.log('itemsProcessed==>', itemsProcessed);
                   if(itemsProcessed === response.length) {
                     var $wrapper = $('#ProductGridContainer .search-product-list');
                     $wrapper.find('.product-search-item').sort(function (a, b) {
                       return +a.dataset.sort - b.dataset.sort;
                   })
                   .appendTo( $wrapper);
                   }          
               });
              }
              
           
          // console.log('ajaxArroooo===>', ajaxArr)



          // $.when.apply(undefined, ajaxArr).then(function() {
          //   var objects = arguments;
          //   var htmlStrings = Array.from(objects).map(a => a[0]);

          //   htmlStrings.forEach(string => {
          //     $('#ProductGridContainer .search-product-list').append(string);
              if(!$('body').hasClass('template-step_new_2')){
                //sortBasedOnTag();
              }              
              hideLoaderforProductGrid();
              if(isPageCollection || $('body').hasClass('template-step_new_2') || $('body').hasClass('template-step_new_3') || $('body').hasClass('template-step_new_1')){
                $('.prod--handle').closest('.product-search-item').hide();
                setTimeout(function(){                        
                   let collName = $('.page-collections').attr('data-collection'); // console.log("collName==>", collName)
                   if(collName == "filter_caps"){
                    collName = "oil_filter_housing_cap";
                   }
                  //  console.log("test", collName);
                   $('.search-product-list .prod--handle[data-collection="'+collName+'"]').closest('.product-search-item').show();
                  // if($('body').hasClass('template-step_new_2') || $('body').hasClass('template-step_new_1')){
                  //   $('#ProductGridWrapper').hide();
                  // }
                  //console.log('visibleproductleng==>', $('.search-product-list .prod--handle[data-collection="'+collName+'"]').closest('.product-search-item:visible').length)
                  if($('.search-product-list .prod--handle[data-collection="'+collName+'"]').closest('.product-search-item:visible').length == 0){
                    // console.log('NNN')
                    //localStorage.setItem("notrequiedmake", make);
                    //window.location.href="/pages/not-available-in-highflow"
                  }
                },200)
              }

              let getColType = [];
                  $('.search-product-list > .product-search-item[data-handle]').each(function(){
                     getColType.push($(this).find('.pro-collection-type').text());
                    
                  })
                  var htmlForFilterType = ''
                  var filtercolType = [];
                  
                  //console.log('getProductType==>', getColType.length, '====================', response.length);
                    let allproductLoaded = setInterval(function(){
                      if(getColType.length === response.length){
                        //console.log('Matching Length Matched==>')
                        filtercolType = getColType.filter((v, i, a) => a.indexOf(v) === i);
                        //console.log('filtercolType Unique values ==>', filtercolType);
                      }
                      setTimeout(function (params) {
                          clearInterval(allproductLoaded)
                        },2000)
                    },0);

                  setTimeout(function (params) {
                    $(document).find('#ProductGridContainer .col-prod-type-filter').remove();
                    if(filtercolType.length > 1){
                      filtercolType = filtercolType.sort();
                      htmlForFilterType += '<div class="col-prod-type-filter"><span class="col-prod-type-filter-label label">Part Type: </span><span class="col-prod-type-filter-selectedvalue kk">All</span><ul><li data-value="" class="selected">All</li>';
                              for (let index = 0; index < filtercolType.length; index++) {
                                htmlForFilterType += '<li data-value="'+filtercolType[index].replaceAll(' ', '_').toLowerCase()+'">'+filtercolType[index]+'</li>';  
                              }
                            htmlForFilterType += '</ul></div>'
                        //console.log('dropdownHTML', htmlForFilterType)
                           $(document).find('#ProductGridContainer .product-dynamic-filter-row').append(htmlForFilterType);
                    }                    
                  },2000);
                  
                
                autoFill = false;
          //     return;
          //   })
            
          // })
        },1000);
        }
      }
          // for (let index = 0; index < response.length; index++) {
          //   let handle = response[index].handle;
          //   let title = response[index].title;
          //   let partNumber = response[index].partNumber;
          //   //let item = '<li>'+title+'</li>';
          //   //$('#ProductGridContainer').append(item)
          //   let origin = window.location.origin;
          //   //let url= ""+origin+"/search/?view=partnumbers?type=product&q=variants.sku:"+partNumber+";
          //   let url= '/products/'+handle+'?view=getproductdata';
          //   $.ajax({
          //     type: 'GET',
          //     url: url,
          //     crossOrigin: true,
          //      async: false,
          //     success: function (data) {
          //       // $(data).filter('.product-search-item').attr('data-make', make);
          //       let prodID = $(data).filter('.product-search-item').attr('data-id'); //console.log('prodID==>', prodID);
          //       let prodLen = $('#ProductGridContainer .search-product-list .product-search-item[data-id="'+prodID+'"]').length;
          //       //$('#ProductGridContainer .search-product-list .product-search-item[data-id="'+prodID+'"]').attr('data-make', make)
          //       //console.log('prodLen==>', prodLen);
          //       if(prodLen == 0){
          //         console.log('ProductLen==>', prodLen, '===', handle);
          //         //getProductHandles.find((el) => el.handle === handle ).html = data;
          //         // $('#ProductGridContainer .search-product-list').append(data);
          //         sortBasedOnTag();
          //         hideLoaderforProductGrid();
          //         //if page is collection
          //         if(isPageCollection || $('body').hasClass('template-step_new_2') || $('body').hasClass('template-step_new_1')){
          //           $('.prod--handle').closest('.product-search-item').hide();
          //           setTimeout(function(){                        
          //              let collName = $('.page-collections').attr('data-collection'); console.log("collName==>", collName)
          //              $('.search-product-list .prod--handle[data-collection="'+collName+'"]').closest('.product-search-item').show();
          //             // if($('body').hasClass('template-step_new_2') || $('body').hasClass('template-step_new_1')){
          //             //   $('#ProductGridWrapper').hide();
          //             // }
          //             //console.log('visibleproductleng==>', $('.search-product-list .prod--handle[data-collection="'+collName+'"]').closest('.product-search-item:visible').length)
          //             if($('.search-product-list .prod--handle[data-collection="'+collName+'"]').closest('.product-search-item:visible').length == 0){
          //               //localStorage.setItem("notrequiedmake", make);
          //               //window.location.href="/pages/not-available-in-highflow"
          //             }
          //           },200)
          //         }
          //         let getColType = [];
          //         $('.search-product-list > .product-search-item[data-handle]').each(function(){
          //            getColType.push($(this).find('.pro-collection-type').text());
                    
          //         })
          //         var htmlForFilterType = ''
          //         var filtercolType = [];
                  
          //         //console.log('getProductType==>', getColType.length, '====================', response.length);
          //           let allproductLoaded = setInterval(function(){
          //             if(getColType.length === response.length){
          //               //console.log('Matching Length Matched==>')
          //               filtercolType = getColType.filter((v, i, a) => a.indexOf(v) === i);
          //               //console.log('filtercolType Unique values ==>', filtercolType);
          //             }
          //             setTimeout(function (params) {
          //                 clearInterval(allproductLoaded)
          //               },2000)
          //           },0);

          //         setTimeout(function (params) {
          //           $(document).find('#ProductGridContainer .col-prod-type-filter').remove();
          //           if(filtercolType.length > 1){
          //             filtercolType = filtercolType.sort();
          //             htmlForFilterType += '<div class="col-prod-type-filter"><span class="col-prod-type-filter-label label">Part Type: </span><span class="col-prod-type-filter-selectedvalue">All</span><ul><li data-value="" class="selected">All</li>';
          //                     for (let index = 0; index < filtercolType.length; index++) {
          //                       htmlForFilterType += '<li data-value="'+filtercolType[index].replaceAll(' ', '_').toLowerCase()+'">'+filtercolType[index]+'</li>';  
          //                     }
          //                   htmlForFilterType += '</ul></div>'
          //               //console.log('dropdownHTML', htmlForFilterType)
          //                  $(document).find('#ProductGridContainer .product-dynamic-filter-row').append(htmlForFilterType);
          //           }                    
          //         },2000);
                  
          //       }
          //       autoFill = false;
          //     },
          //     error:  function (xhr, err) {
          //       //console.log('json error:- ' + err.status );
          //       $('#ProductGridContainer .search-heading').find('span').text("We're sorry, there is no HIGHFLOW® "+make+" product available for your vehicle at this time.");
          //       //localStorage.setItem("notrequiedmake", make);
          //       window.location.href = '/pages/not-required';
          //     }
          //   }); 
          // } 
       // }
        
        ;
        //scroll to search result
        //scrollToResult();
      
  //}

  // Print Year DropDown from Year API Response

  function printYearDropdownfromYearAPIResonse(getYearsList){
    $(document).find('.col-prod-year-filter').remove();
    let yearDropDown = '';
    yearDropDown += '<div class="col-prod-year-filter"><span class="col-prod-year-filter-label label">Year : </span><div class="col-prod-year-filter-content-wrapper"><span class="col-prod-year-filter-selectedvalue">All</span><ul><li data-value="" class="selected">All</li>';
    for (let index = 0; index < getYearsList.length; index++) {
      yearDropDown += '<li data-value="'+getYearsList[index]+'">'+getYearsList[index]+'</li>';  
    }
    yearDropDown += '</ul></div></div>'
    //console.log('dropdownHTML==>', yearDropDown)
    $(document).find('#ProductGridContainer .product-dynamic-filter-row').append(yearDropDown);
  }


  // Print Pagination from Year API Response
  //printPaginationfromYearAPIResponse(totalPageCount, pageDividedBy, firstPageLink, nextPageLink, lastPageLink, prevPageLink);
  function printPaginationfromYearAPIResponse(totalPageCount, pageDividedBy, firstPageLink, nextPageLink, lastPageLink, prevPageLink, currentPage, lastPage, partNumber){
    $(document).find('.paginationfromyearapi').remove();
      //console.log("paginationData==>", totalPageCount,'==',pageDividedBy,'==',firstPageLink,'==',nextPageLink,'==',lastPageLink,'==',prevPageLink, currentPage, lastPage, partNumber);
      let nextPage = currentPage+1;
      if(currentPage > 1){
        var prevPage = currentPage-1;
      } else {
        var prevPage = currentPage;
      }
      
      var paginationHtml = '';

      paginationHtml += '<div class="paginationfromyearapi"><ul>';
      if(currentPage > 1) {
        paginationHtml += '<li data-label="first" data-part="'+partNumber+'" data-page="1"><a href="javascript:;" aria-label="First Page">First</a></li>';
        paginationHtml += '<li data-label="previous" data-part="'+partNumber+'" data-page="'+prevPage+'"><a href="javascript:;" aria-label="Previous Page">Previous</a></li>';
        
      }      
      
      if(currentPage < lastPage){
        paginationHtml += '<li data-label="current" data-part="'+partNumber+'" data-page="'+currentPage+'"><a href="javascript:;" aria-label="Page '+currentPage+'">'+currentPage+'</a></li>';
      paginationHtml += '<li data-label="next" data-part="'+partNumber+'" data-page="'+nextPage+'"><a href="javascript:;" aria-label="Page '+nextPage+'">'+nextPage+'</a></li>';
      paginationHtml += '<li data-label="divider" ><a href="javascript:;" aria-label="divider">...</a></li>';
      paginationHtml += '<li data-label="last" data-part="'+partNumber+'" data-page="'+lastPage+'"><a href="javascript:;" aria-label="Page '+lastPage+'">'+lastPage+'</a></li>';
      paginationHtml += '<li data-label="nextpage" data-part="'+partNumber+'" data-page="'+nextPage+'"><a href="javascript:;" aria-label="Next Page">Next</a></li>';
      }
      paginationHtml += '</ul></div>'

      $('#ProductGridContainer').append(paginationHtml);

  }


  // Event for Paginations

  $(document).on('click', '.paginationfromyearapi li', function(){
    
    let pageLabel = $(this).attr('data-label');
    let pagePartNumber = $(this).attr('data-part');
    let pageNumber = $(this).attr('data-page');
    // Scroll + lock height BEFORE clearing products (avoids footer flash on Next).
    isInitialPageLoad = false;
    pinResultsViewport();
    showLoaderforProductGrid();
    $(document).find('.paginationfromyearapi, .col-prod-year-filter').remove();
    
    if($('body').hasClass('template-step_new_2') || $('body').hasClass('template-step_new_3')){
      var key = $('.page-collections').attr('data-collection');
      var duty = $('select[data-searchby-duty]').val();
      var year = $('select[data-searchby-year]').val();
      var make = $('select[data-searchby-make]').val();
      var model = $('select[data-searchby-model]').val();
      getProductsAfterHitPagniationWithNewFilter(key, duty, year, make, model, pageNumber);
    }else {
      getYearAfterHitProductPartNumberAPI(pagePartNumber, pageNumber);
    }
    
  })

  
  /*###### End Dynamic search ############################################################*/
  
  //save partnumber data in localstorage
  $(document).on('click', '.search-product-list a', function(){
     localStorage.setItem('partnumber_data',JSON.stringify(partNumberLocalData));
     localStorage.setItem('reload_search','true');
    
      // if($('#classic-search-container select#termYear').val() == '' && $('#dynamic-search').val() != ''){
      //   var createBackToStringbyDyncSrch = '/search?dsfilter='+$('#dynamic-search').val();
      //   localStorage.setItem('backToSearchHistorybyDynamicSearch', createBackToStringbyDyncSrch);
      //   localStorage.removeItem('backToSearchHistory, backToSearchHistorybyVIN');
      // } else if($('#classic-search-container select#termYear').val() == '' && $('#dynamic-search').val() == '' && $('#vin-number').val() != ''){
      //   var getVINRegionId = $('#vin-search-container select[name="RegionID"]').val();
      //   var createBackToStringbyVIN = '/search?vinfilter='+$('#vin-number').val()+'|'+getVINRegionId;
        
      //   localStorage.setItem('backToSearchHistorybyVIN', createBackToStringbyVIN);
      //   localStorage.removeItem('backToSearchHistory, backToSearchHistorybyDynamicSearch');
      // }else {
      //   var createBackToString = '/search?hpfilter='
      //    $('#classic-search-container select').each(function(){
      //      createBackToString += $(this).val()+',';
      //   })    
      //   createBackToString = createBackToString.replace(/,\s*$/, "");
      //   localStorage.setItem('backToSearchHistory', createBackToString);
      //   localStorage.removeItem('backToSearchHistorybyVIN, backToSearchHistorybyDynamicSearch');
      // }
      
       
  })
  
  //reload parnumbersData on back
  function reloadDataOnRefresh(){ 
      //console.log('Reload search data processed...');
      let reloadData = localStorage.getItem('reload_search');
      ////console.log('ReloadData: ', reloadData);
      if(reloadData != undefined && reloadData != ''){
        let localData = JSON.parse(localStorage.getItem('partnumber_data'));
        ////console.log("localData: ",localData);
        if(localData != '' && localData != undefined){ 
          ////console.log('Reload partnumber...');  
          //console.log('4')     
          partNumbers(localData.data, localData.year, localData.make, localData.model, localData.engine, localData.engineLabel);
          
          localStorage.removeItem('reload_search');
        }
      }
    }

  /*###### reset filter fields #########*/
  function resetSearchFields(itemIndex, itemEle){
        // Hide no products message when starting new search
        if (typeof window.hideNoProductsMessage === 'function') {
          window.hideNoProductsMessage();
        }
        $('#engineBaseId').show();
    // console.log("itemIndex==>: ",itemIndex,"itemEle:==> ",itemEle)
    if(itemIndex != undefined && itemEle != undefined){
      let checkArr = [];
      $(itemEle).closest('.brator-parts-reset').find('select').each(function(){
        checkArr.push($(this).attr('id'))
      })
      ////console.log("checkArr: ",checkArr)
      let thisID = $(itemEle).attr('id');
      let isQualifier = false;
      if($(itemEle).hasClass('qualifier-select')){
        isQualifier = true;
      }
      ////console.log("thisID: ",thisID)
      let itemIdex = checkArr.indexOf(thisID);    
    //console.log("itemIdex====>: ",itemIdex)
      if(itemIdex > -1){
        for(let i = 0; i < checkArr.length; i++){
          ////console.log("itemIdex: ",itemIdex);
        //console.log("i====>>: ",checkArr[i]);
          //check for next element of current changed element
          if(i > itemIdex){
            //disabled next to next all element
            //$('select#'+checkArr[i]+'').select2("enable", false)
            //if next select box has options
            ////console.log('select#'+checkArr[i]+'')
            if($('select#'+checkArr[i]+' option').length > 0){
              if(isQualifier){
                //console.log('isQualifier: ','true');
                $(document).find('select#'+checkArr[i]+'').remove();
              }
              else{
                ////console.log('isQualifier: ',checkArr[i]);
                //$('select#'+checkArr[i]+'').select2("val", null);
                /*if(checkArr[i] == 'termYear' || checkArr[i] == 'termMake' || checkArr[i] == 'termModel' || checkArr[i] == 'engineBaseId'){
                  $(itemEle).closest('.brator-parts-reset').find('select.qualifier-select').remove();
                }*/
                $('select#'+checkArr[i]+'').find('option:not(:first-child)').remove();
                //console.log('seletIdLength===>', $('select#'+checkArr[i]+'').length)
                if($('select#'+checkArr[i]+'').length > 0){
                  $('select#'+checkArr[i]+'').select2("enable", false);
                  $('select#'+checkArr[i]+'').select2('destroy');
                  $('select#'+checkArr[i]+'').select2();
                }
                $(itemEle).closest('.brator-parts-reset').find('select.qualifier-select').each(function(){
                  $(this).select2('destroy')
                })
                $(itemEle).closest('.brator-parts-reset').find('select.qualifier-select').remove();
              }
            }
          } 
        }
      }
    }
  }

  //auto select if comes from homepage
  function autoSelectFromAddressBar(){    
    //console.log('AutoSelectFromAddressBarr============>>>>>>>>');
    URLValues.forEach((key, ind) => {
      //console.log(key,'==',ind);
    });
    var URLParameter = {
      "termDuty": URLValues[0],
      "termYear": URLValues[1],
      "termMake": URLValues[2],
      "termModel": URLValues[3],
      "baseVehicleId": decodeURIComponent(URLValues[4])
    }
    //console.log('URLParameter==>', URLParameter);
    if(getURL.indexOf('search?hpfilter') > -1){
      var checkTermDuty = setInterval(function(){
        if($('#termDuty option').length > 1){
          $('#termDuty').val(URLValues[0]).change();
          ////console.log('change checkTermDuty: ',URLValues[0])
          clearInterval(checkTermDuty);
        }
      },100)
      var checkTermYear = setInterval(function(){
        if($('#termYear option').length > 1){
          $('#termYear').val(URLValues[1]).change();
          ////console.log('change checkTermYear: ',URLValues[1])
          clearInterval(checkTermYear);
        }
      },100)
      var checkTermMake = setInterval(function(){
        if($('#termYear').val() == URLValues[1]){
          $('#termMake').val(URLValues[2]).change();
          ////console.log('change checkTermMake: ',URLValues[2])
          clearInterval(checkTermMake);
        }
      },100)
      var checkTermModel = setInterval(function(){
        if($('#termMake').val() == URLValues[2]){
          $('#termModel').val(URLValues[3]).change();
          ////console.log('change checkTermModel: ',URLValues[3])
          clearInterval(checkTermModel);
        }
      },100)
      var checkBaseVehicleId = setInterval(function(){
        if($('#engineBaseId').val() == URLValues[4]){
          $('#engineBaseId').val(URLValues[4]).change();
          //console.log('change checkBaseVehicleId: ',URLValues[4])
          clearInterval(checkBaseVehicleId);
        }
      },100)
    }
  }



  /*######## Get URL Information from PDP Back Button ############################# */
  function searchFromPDPBackButton(getURL){  

    if($('body').hasClass('template--search')){
      //console.log('insidebackbuttonunc');
      var splitData = getURL.split('/search?backbtnfilter=')[1];
    var jsonObjData = $.parseJSON(decodeURIComponent(splitData));

   //console.log(jsonObjData);

    jsonObjData.forEach((key, val) => {

      //console.log('inside forEach', key);
    
        //console.log('inside interval');
       setTimeout(function(){
        var checkClassicFilterAutofill = setInterval(function(){
          let id = key.id; //console.log('ID==>', id)
        let v = key.value; //console.log('Value==>', v);
         if($(document).find('select#'+id).length > 0){
          $(document).find('select#'+id).val(v).trigger('change');
            //$(document).find('select#'+id).change();
            clearInterval(checkClassicFilterAutofill);
        // // //console.log('change==> select#'+id, v)
        
         }
        },1000)
        
        //clearInterval(checkClassicFilterAutofill);
      },1000)
      ////console.log(val);


    });

    }
  }


  

  /*###### VIN search ############################################################*/
  
  let VINDataKeys = ["termYear", "termModel", "termMake", "engine", "engineBaseId", "baseVehicleId"];
  let VINRequestData = {};
  $('#btn-check-vin').on('click', function(){
    $('.vin-search-overlay').addClass('open');
    $('#dynamic-search').val('');
    $('#dynamic-search-container .form-block').not(':first').remove();
    resetSearchFields(0, '#termYear');
    $('#classic-search-container select#termYear').val('').change();

    
    //$('#vin-search-container select').select2('destroy');
    $('#vin-search-container .form-block:not(:first-child)').remove();
    //check VIN
    let vin_number = $('#vin-number').val();
    setTimeout(function(){
      
      VINSearch(vin_number)
    },2000)
    
  });

  //On VIN more qualifier change
  $(document).on('change', '#vin-search-container select', function(){
    $(this).nextAll('select').remove();
    let thisVal = $(this).val();
    let clickedQualifier = $(this).attr('name');
      ////console.log('clickedQualifier',clickedQualifier)
      //alert('VINDataKeys[thisVal]', VINDataKeys[clickedQualifier])
    let checkQualifierExist = VINDataKeys[clickedQualifier] in VINRequestData;
    VINRequestData[clickedQualifier] = thisVal;
    /*if(checkQualifierExist == true){
      //console.log('thisVal', thisVal)
      //console.log('clickedQualifier', clickedQualifier)
      VINRequestData[clickedQualifier] = thisVal;
    }*/
    getVINQualifier(VINRequestData)
  })

  // Search By VIN number 
  function VINSearch(vin_number){    
    const vinURL = `${vinAPI}/${vin_number}`;
    $.ajax({
      type: "GET",
      url: vinURL,
      crossOrigin: true,
      success: function (resData) {
        resData = JSON.parse(resData);
        let response = resData.res;
        //console.log('VIN Search Response-1');
        ////console.log("response: ",response)
        //response format BaseVehicleID!!EngineBaseID!!Engine!!Make!!Model!!Year
        //let data = "118609!!4247!!1.6!!Ford!!Fiesta!!2012!!";
        response = response.split(',').filter(Boolean).reverse();
        // get year, make, model
        for(let i = 0; i < response.length; i++){
          if(i < response.length){
            VINRequestData[VINDataKeys[i]] = response[i]
          }
        }
        ////console.log("VINRequestData vin: ",VINRequestData);
        getVINQualifier(VINRequestData)
      },
      error: function(err){
        //console.log('error: ',err)
      }
    })
      
  }
  
  //Get VIN Qualifier
  async function getVINQualifier(VINRequestData){
    // console.log("VINRequestData vin: ",VINRequestData);
    $('.vin-search-overlay').addClass('open');
    const keysToExclude = ["termYear", "termMake", "termModel", "engine", "baseVehicleId", "engineBaseId"];
    

    for (const key in VINRequestData) {
        if (!keysToExclude.includes(key)) {
          extractedValues.add(VINRequestData[key]);
        }
    }
    let choosenQualValues = Array.from(extractedValues);

    // console.log("choosenQualValues",choosenQualValues);

    // console.log("testing for values", VINRequestData);

    // let searchTermArr = searchValueId?.split('!');

    // let searchIDs = {
    //   year: searchTermArr[0],
    //   make: searchTermArr[1],
    //   model: searchTermArr[2],
    //   engine: searchTermArr[3]
    // }

    let vinNumberOrPartNumberURL;

    // console.log("selectedDynQual", selectedDynQual);

    if(choosenQualValues.length == 0){
      let qualifierCheckURL = `${API_BASE_URL}/qualifiersforAllPartTypes/${VINRequestData.baseVehicleId}/${VINRequestData.engineBaseId}/noqualifier/0/0`;
      let testQualifiers = await fetch( qualifierCheckURL ,{
        method:"GET",
        mode:"cors",
      }).then(async response => {
          return await response.json();
      }).then(json => {
          return json;
      });

      
      if(testQualifiers == "fail"){
        vinNumberOrPartNumberURL = `${API_BASE_URL_HIGHFLOW}/productList/${VINRequestData.baseVehicleId}/${VINRequestData.engineBaseId}/noqualifier/noqualifier`;
      }
      else if(testQualifiers.name?.length != 0 && testQualifiers.values?.length != 0){
        vinNumberOrPartNumberURL = qualifierCheckURL;
        
      }
      else{
        vinNumberOrPartNumberURL = `${API_BASE_URL_HIGHFLOW}/productList/${VINRequestData.baseVehicleId}/${VINRequestData.engineBaseId}/noqualifier/noqualifier`;
        
      }
    }
    else if(choosenQualValues.length > 0){

      const _len = choosenQualValues.length - 1;
      const __tempVal = choosenQualValues[_len];
      const currentQualifier = __tempVal ? __tempVal[1].split('_') : [];
      const qualifierID = encodeURIComponent(currentQualifier[0]);
      const qualifierName = encodeURIComponent(currentQualifier[1]);
      
      let arrayQualID = [];
      let arrayID = [];
      let arrayQualNames = [];

      choosenQualValues.forEach(item => {
        let parts = item.split('_');
        arrayQualID.push(parts[0]);
        arrayQualNames.push(parts[1]);
      });

      arrayQualID.forEach(item => {
        let parts = item.split(':');
        arrayID.push(parts[1]);
      });

      let encodedQualNames = arrayQualNames.map(item => encodeURIComponent(item));
      let encodedQualId = arrayQualID.map(item => encodeURIComponent(item));


      let qualId = arrayQualID.length > 1 ? arrayQualID.join(',') : arrayQualID[0] || '';
      let _id = arrayID.length > 1 ? arrayID.join(',') : arrayID[0] || '';
      let qualNames = encodedQualNames.length > 1 ? encodedQualNames.join(',') : encodedQualNames[0] || '';
      let _encodedQualId = encodedQualId.length > 1 ? encodedQualId.join(',') : encodedQualId [0] || '';

      let qualifierCheckURL = `${API_BASE_URL}/qualifiersforAllPartTypes/${VINRequestData.baseVehicleId}/${VINRequestData.engineBaseId}/${qualId}/0/0`;
      let testQualifiers = await fetch( qualifierCheckURL ,{
        method:"GET",
        mode:"cors",
      }).then(async response => {
          return await response.json();
      }).then(json => {
          return json;
      });
      // console.log("Came here", testQualifiers);
      if(testQualifiers.values == 0){
        // console.log("should come here.")
        vinNumberOrPartNumberURL = `${API_BASE_URL}/productList/${VINRequestData.baseVehicleId}/${VINRequestData.engineBaseId}/${_encodedQualId}/${qualNames}`;
      }
      else if(testQualifiers.name?.length != 0 && testQualifiers.values.length != 0){
        vinNumberOrPartNumberURL = qualifierCheckURL;
      }
    }

    $.ajax({
      type: 'GET',
      url: vinNumberOrPartNumberURL,
      crossOrigin: true,
      success: function (resData) {
        // data = JSON.parse(data);
        // console.log('VIN Search Response-2');
        // console.log("data: ",resData);

        let data = {}
        data.response = resData.values;
        const resName = resData?.values ? resData?.values[0]?.id.split(':') : "";
        data.name = resName ? resName[0] : "";
        // console.log("test", data);

        if(determineDataType(resData) == "JSON string"){
          resData = JSON.parse(resData);
        }

        if(resData.partTypeArray != undefined){
          // const mergedPartNumbersArray = [].concat(resData.partTypeArray, resData.CapsAndPlugsArray, resData.WiperBlades, resData.Fluids);
          const mergedPartNumbersArray = [].concat(resData.partTypeArray, resData.WiperBlades);
          data.response = mergedPartNumbersArray;
          data.name = "part_numbers";
          // console.log("inside merged array if")
          // console.log("merged Array", mergedPartNumbersArray);
        }
        

        if(data.name == "part_numbers"){
          let make = VINRequestData['termMake'];
          let year = VINRequestData['termYear'];
          let model = VINRequestData['termModel'];
          let engine = VINRequestData['engine'];
          let engineLabel = VINRequestData['engine'];
          //let engineLabel = $('select[data-searchby-engine] option[value="'+engine+'"]').attr('data-label');
          //console.log('5')
          //console.log('Result from VIN');
          partNumbers(data, year, make, model, engine, engineLabel)
          
            localStorage.setItem('backButtonHistoryfromPDP','/search?vinSearchfilter='+$('#vin-number').val());
            $('.vin-search-overlay').removeClass('open');
          //$('#termYear').val('').change();
          //$('#dynamic-search-container #dynamic-search').val('');
          // if($('#dynamic-search-container .form-block').length > 1){
          //   $('#dynamic-search-container #dynamic-search').closest('.form-block').siblings('.form-block').remove();  
          // }
          
          
        }
        else{
          addVINQualifier(data)          
        }
      },
      error:  function (xhr, err) {
        //console.log('json error' + err.status );
      }
    });    
  }
  
  //Add VIN Qualifier
  function addVINQualifier(data){
    let response = data.response;
    if(response.length > 0){
      let qualifier = '';
      let keyName = data.name;
      for(let i = 0; i < response.length; i++){
        let obj = response[i];
        let keyID = obj[keyName];
        if(keyID == undefined){
          let objItem = response[i];
          let itemKeys = Object.keys(objItem);
          ////console.log("itemKeys: ",itemKeys)
          for(let i = 0 ; i< itemKeys.length; i++){
            if(itemKeys[i].indexOf('ID') > -1 || itemKeys[i].indexOf('Id') > -1){
              ////console.log("itemKeys exist: ",itemKeys)
              if(itemKeys[i] != undefined){
                let objItemKey = itemKeys[i];
                ////console.log("objItemKey: ",objItemKey)
                keyID = obj[objItemKey]
                ////console.log("keyID: ",keyID)
              }
            }
          }
        }        
        //console.log("keyName: ",keyName)
        qualifier += '<option data-label="'+response[i].values+'" value="'+response[i].id+'_'+response[i].values+'">'+response[i].values+'</option>'
      }
      let createQualifierSelect = '<select data-placeholder="'+keyName+'" name="'+keyName+'" class="custom-select"><option value="">'+keyName+'</option>'+qualifier+'</select>';
      $('#vin-search-container').append('<div class="form-block">'+createQualifierSelect+'</div>');
      $('.vin-search-overlay').removeClass('open');
      $(document).find('select[name="'+data.name+'"]').select2({
          placeholder: $(this).attr('data-placeholder')
      });

      //auto select if only 1 data in response
      setTimeout(function(){
        if(response.length == 1){
          //console.log("response.length ", response.length);
          $('select[name="'+data.name+'"]').val($('select[name="'+data.name+'"] option[data-label]').val()).change();
          //$('select#engineBaseId').change();
        }                 
        $(document).find('select[name="'+data.name+'"]').select2().on('select2:open', function () {
          var a = $(this).data('select2');
          var placeholder = $(this).attr('data-placeholder');
          if (!$('.select2-link').length) {
            a.$results.parents('.select2-results').find('.custom-select2-label').remove();
            a.$results.parents('.select2-results')
              .prepend("<span class='custom-select2-label'>"+placeholder+"</span>")
              .on('click', function (b) {
              a.trigger('close');
            });
          }
        });
      },500)
    }
  }


// function update Search heading
function updateSearchHeading(key, duty, year, make, model, engineLabel){
  // console.log('Heading updates', key,'==' ,duty,'==' ,year,'==' ,make,'==' ,model,'==' ,engineLabel)
  var searchHeading = ''
   if(key != "" && duty != "" && year != "" && make != "" && model != "" && engineLabel !=""){
    searchHeading = key+' '+year+' '+make+' '+model+' '+engineLabel;
    $('#ProductGridContainer .search-heading').find('span').text(searchHeading);
   } else if(key != "" && duty != "" && year == "" && make == "" && model == "" && engineLabel ==""){
    searchHeading = key;
    $('#ProductGridContainer .search-heading').find('span').text(searchHeading);
   } else if(key != "" && duty != "" && year != "" && make == "" && model == "" && engineLabel ==""){
    searchHeading = key+' '+year;
    $('#ProductGridContainer .search-heading').find('span').text(searchHeading);
   }else if(key != "" && duty != "" && year != "" && make != "" && model == "" && engineLabel ==""){
    searchHeading = key+' '+year+' '+make;
    $('#ProductGridContainer .search-heading').find('span').text(searchHeading);
   }else if(key != "" && duty != "" && year != "" && make != "" && model != "" && engineLabel ==""){
    searchHeading = key+' '+year+' '+make+' '+model;
    $('#ProductGridContainer .search-heading').find('span').text(searchHeading);
   }else if(key != "" && duty != "" && year != "" && make != "" && model != "" && engineLabel !=""){
    searchHeading = key+' '+year+' '+make+' '+model;
    $('#ProductGridContainer .search-heading').find('span').text(searchHeading);
   } else if(key == "" && duty == "" && year != "" && make != "" && model != "" && engineLabel !=""){
    searchHeading = year+' '+make+' '+model+' '+engineLabel;
    $('#ProductGridContainer .search-heading').find('span').text(searchHeading);
   } 
}

  // Show Loader
function showLoaderforProductGrid(){
  if(!$('body').hasClass('template-index')){
    // console.log('insideShowLoader')
    $('.brator-cart-item-list-overlay').addClass('open')
    $('#ProductGridContainer').removeAttr('data-sliderbar-enable');
    // If caller did not pin first, pin now so emptying the list cannot reveal the footer.
    var grid = document.getElementById('ProductGridContainer');
    if (grid && !grid.style.minHeight) {
      pinResultsViewport();
    }
    $('#ProductGridContainer .search-product-list').html('');
    //$('#ProductGridContainer .search-product-list').addClass('waiting-result');
    //if($('body').hasClass('template-step_new_2') || $('body').hasClass('template-step_new_3')){
      $('#ProductGridContainer').show(); 
    //}
    $('.paginationfromyearapi').removeClass('show-pagination')
  } 
}
 

  // Hide Loader
  function hideLoaderforProductGrid(){
    $('.brator-cart-item-list-overlay').removeClass('open')
    // if(!$('body').hasClass('template-step_new_2')){
    //   $('#ProductGridContainer').attr('data-sliderbar-enable', true);
    // }
    // if(!$('body').hasClass('template-step_new_3')){
    //   $('#ProductGridContainer').attr('data-sliderbar-enable', true);
    // }    
    if($('body').hasClass('template-step_new_2') || $('body').hasClass('template-step_new_3')){
      $('#ProductGridContainer').removeAttr('data-sliderbar-enable');
    } 
    
    if($('body').hasClass('template-search')){
      $('#ProductGridContainer').attr('data-sliderbar-enable', true);
    }
    //$('#ProductGridContainer .search-product-list').removeClass('waiting-result');
    $('.paginationfromyearapi').addClass('show-pagination');
    $('#ProductGridContainer h2.search-heading').show(); 
    
  }

  function sortBasedOnTag(){
    
    var itemsProcessed =  0;
    const selectorArray = ["FT_Highflow_Air_Filter", "FT_Standard_Air_Filter", "FT_Pureflow_Cabin_Filter", "FT_Standard_Cabin_Filter", "FT_Extended_Life_Oil_Filter", "FT_Standard_Oil_Filter", "FT_Transmission_Filter", "FT_Fuel_Filter"];
    selectorArray.forEach((ele, index) => {
      // console.log(ele, '==', index);
      $('.search-product-list .product-search-item .prod--handle.brator-product-single-item-area[data-resultsort="'+ele+'"]').closest('.product-search-item').attr('data-sort', index);
        itemsProcessed++;
        //console.log('itemsProcessed==>', itemsProcessed);
        if(itemsProcessed === selectorArray.length) {
          var $wrapper = $('#ProductGridContainer .search-product-list');
          // console.log('visible Item Length==>', $('#ProductGridContainer .search-product-list .product-search-item:visible').length);
          //if($('#ProductGridContainer .search-product-list .product-search-item:visible').length > 1){
            $wrapper.find('.product-search-item').sort(function (a, b) {
              return +a.dataset.sort - b.dataset.sort;
          })
          .appendTo( $wrapper);
          //}
          
        }          
    });
  }

// $(document).on('change', '.col-prod-type-filter select', function() {
//   $('#ProductGridContainer .search-product-list .product-search-item').removeClass('result-with-filter').hide();
//   let getSelectVal = $(this).val();
  
// });

// $(document).on('click', '.col-prod-type-filter-selectedvalue', function(){
//   if($(this).next('ul').is('vislible')){
//     $(this).next('ul').slideUp();
//   }else {
//     $(this).next('ul').slideToggle();
//   }
  
// });
let getSelectVal = [];
$(document).on('change', '.col-prod-type-filter ul li input', function(){
  // let getSelectVal = $(this).attr('data-value');

  if(this.checked){
    getSelectVal.push($(this).attr('data-value'))
}
else {
  
  getSelectVal = getSelectVal.filter(item => item != $(this).attr('data-value'));
}

   // console.log("getSelectVal==>", getSelectVal);
  $('#ProductGridContainer .search-product-list .product-search-item').removeClass('result-with-filter').hide();
  if(getSelectVal == '' || getSelectVal == 'all'){
    $('#ProductGridContainer .search-product-list .product-search-item').removeClass('result-with-filter').show();
  } else {
    if($(this).attr('data-check')=='all'){
      $('#all').attr('checked',true);
      $('.clear_search').hide();
     }else{
      $('#all').attr('checked',false);
      $('.clear_search').show();

     }
    for(i=0;i<getSelectVal.length;i++){
      if(getSelectVal[i] == ''){
        $('#ProductGridContainer .search-product-list .product-search-item').removeClass('result-with-filter').show();

      }else{
    $('#ProductGridContainer .search-product-list .product-search-item [data-collection^="'+getSelectVal[i]+'"]').closest('.product-search-item').addClass('result-with-filter');
      const productItem = $('#ProductGridContainer .search-product-list .product-search-item [data-collection^="'+getSelectVal[i]+'"]').closest('.product-search-item');
        // console.log(productItem.attr('data-handle'));
        if(productItem.attr('data-handle') == "non-serviceable"){
          // console.log("inside if")
          window.location.href = `/pages/non-serviceable?col=${$(this).attr('data-value')}`;
        }
        else if(productItem.attr('data-handle') == "not-required"){
          window.location.href = `/pages/not-required?col=${$(this).attr('data-value')}`;
        }
      }
    }
  }
  $(document).find('.col-prod-type-filter-selectedvalue').text($(this).text());
  // $(this).closest('ul').slideToggle();
})
$(document).on('click', '.clear_search', function(){
   getSelectVal = [];
   $('#ProductGridContainer .search-product-list .product-search-item').removeClass('result-with-filter').show();
   $('.col-prod-type-filter input').attr('checked',false);
   $('#all').attr('checked',true);
});
// $(document).mouseup(function(e) {
//     var container = $(".col-prod-type-filter ul");

//     // if the target of the click isn't the container nor a descendant of the container
//     if (!container.is(e.target) && container.has(e.target).length === 0) 
//     {
//         container.slideUp();
//     }
// });

$(document).on('click', '.col-prod-year-filter-selectedvalue', function(){
  if($(this).next('ul').is('vislible')){
    $(this).next('ul').slideUp();
  }else {
    $(this).next('ul').slideToggle();
  }
  
});

$(document).on('click', '.col-prod-year-filter ul li', function(){
  $(document).find('.paginationfromyearapi').remove();
  $(document).find('.col-prod-year-filter-selectedvalue').text($(this).text());
  $(this).closest('ul').slideToggle();
  let selectedyear = $(this).attr('data-value'); //console.log('selelcted data year', selectedyear);
  let selectedPartNumber = $('#dynamic-search').val(); //console.log('SelectedPart Number', selectedPartNumber);
  showLoaderforProductGrid();
  if( selectedyear == ''){
    getYearAfterHitProductPartNumberAPI(selectedPartNumber)
  }else {
    let apiData = {"sku": selectedPartNumber, "year":selectedyear}
    
    $.ajax({
      type: 'POST',
      url: "https://high.pgiproduct.com/search/api/v2/common/getProductList",
      crossOrigin: true,
      data: apiData,
      success: function (responsebyYearAndPartNumber) {

        //console.log("responsebyYearAndPartNumber==>", responsebyYearAndPartNumber.response)
        let getProductHandles = responsebyYearAndPartNumber.response;
          printProductfromYearAPIResponse(getProductHandles);
      },
      error:  function (xhr, err) {
        //console.log('json error' + err );
        //console.log('json erro===>', xhr);
      }
    });
  }
})
  
/*###### END VIN number #########*/

  //reloadDataOnRefresh
  $(window).on('load', function(){
    if($('body.template--search').length > 0){
      //reloadDataOnRefresh();
    }
    if($('body.template--index').length > 0){
      localStorage.removeItem('reload_search');
    }
    autoSelectFromAddressBar();
    //searchFromPDPBackButton(getURL);
    $(document).find('.select2-container').attr('tabindex', 0);
  })

  $('body').on('click', '#reset-filter-btn', function(){
    autoFill = false;
    $('#reset-filter-btn').addClass('d-none');
    $('#ProductGridContainer').attr('data-sliderbar-enable', 'false');
    $('#classic-search-container select:not("#termDuty")').val('');
    $('#classic-search-container select:not("#termDuty")').trigger('change');
    $('#termYear').select2('open');
  });

  $.fn.once = function (events, callback) {
    return this.each(function () {
        $(this).on(events, myCallback);
        function myCallback(e) {
            $(this).off(events, myCallback);
            callback.call(this, e);
        }
    });
  };

  // monitor every time we're about to close a menu
  $("body").on('select2:closing', function (e) {
    var $sel2 = $(e.target).data("select2");
    var $sel = $sel2.$element;
    var $selDropdown = $sel2.$results.find(".select2-results__option--highlighted");
    var newValue =  $selDropdown.data("data").element.value;

    $("html").once('keyup mouseup', function (e) {
        // if close was due to a tab, use the highlighted value
        var KEYS = { UP: 38, DOWN: 40, TAB: 9 }
        if (e.keyCode === KEYS.TAB) {
            if (newValue != undefined) {
                $sel.val(newValue);
                $sel.trigger('change');
            }
        }
    });
  });

  $('body').on('blur', '#pdp-quantity-field', function() {
    var recc_qty = parseInt($(this).val());
    if(recc_qty < 1) {
      $(this).val('1');
    }
  });
  
  window.onload = function(){
    const pdpUrl = window.location.href;
    if(pdpUrl.includes("notify=true")){
      setTimeout(() => {
        var swymBtn = document.querySelector('.swym-add-to-watchlist.swym-button');
        if(swymBtn) {
          swymBtn.click();
        }
      }, 500);
    }
  };

})(window.jQuery);

